export default {
    "de": {
        "enemizer": {
            "title": "Enemizer",
            "enable": "Aktiviere Enemizer",
            "disable": "Deaktiviere Enemizer",
            "enemy_health": {
                "title": "Gegner Leben",
                "options": [
                    "Regulär",
                    "Einfach (1-4 hp)",
                    "Mittel (2-15 hp)",
                    "Schwer (2-30 hp)",
                    "Wahnsinnig (4-50 hp)"
                ]
            },
            "enemy_damage": {
                "title": "Gegner Schaden",
                "options": {
                    "off": "Regulär",
                    "shuffle": "Durcheinander",
                    "chaos": "Chaos"
                }
            },
            "bosses": {
                "title": "Bosse",
                "options": {
                    "off": "Regulär",
                    "basic": "Basis",
                    "normal": "Normal",
                    "chaos": "Chaos"
                }
            },
            "palette_shuffle": "Palettenmischung",
            "pot_shuffle": "Topf mischen",
            "enemy_shuffle": "Gegner mischen"
        },
        "randomizer": {
            "title": "Randomizer",
            "preset": {
                "title": "Wähle Voreinstellungen",
                "customize": "Customire",
                "options": {
                    "default": "Default",
                    "beginner": "Beginner",
                    "veetorp": "OWG (Veetorp’s Favorit)",
                    "crosskeys": "Crosskeys",
                    "quick": "Super Schnell",
                    "nightmare": "Albtraum",
                    "tournament": "Turnier",
                    "custom": "Benutzerdefiniert"
                }
            },
            "placement": {
                "title": "Gegenstandsplatzierung"
            },
            "item_placement": {
                "title": "Gegenstandsplatzierung",
                "options": {
                    "basic": "Basis",
                    "advanced": "Erweitert"
                }
            },
            "dungeon_items": {
                "title": "Palastgegenstände",
                "options": {
                    "standard": "Standard",
                    "mc": "Karten/Kompässe",
                    "mcs": "Karten/Kompässe/kleine Schlüssel",
                    "full": "Keysanity"
                }
            },
            "accessibility": {
                "title": "Zugänglichkeit",
                "options": {
                    "items": "100% Inventar",
                    "locations": "100% der Orte",
                    "none": "Schaffbar"
                }
            },
            "glitches_required": {
                "title": "Vorausgesetzte Glitches",
                "options": {
                    "none": "Keine",
                    "overworld_glitches": "Overworld Glitches",
                    "hybrid_major_glitches": "Hybrid Major Glitches",
                    "major_glitches": "Major Glitches",
                    "no_logic": "Keine Logik"
                },
                "glitch_warning": "Diese Einstellung setzt Wissen von Major Glitches voraus<sup>**</sup>"
            },
            "goal": {
                "title": "Ziel",
                "options": {
                    "ganon": "Besiege Ganon",
                    "fast_ganon": "Fast Ganon",
                    "dungeons": "Alle Dungeons",
                    "pedestal": "Master-Schwert Sockel",
                    "triforce-hunt": "Triforce-Splitter",
                    "ganonhunt": "Ganonjagd"
                }
            },
            "tower_open": {
                "title": "Turm öffnen",
                "options": {
                    "0": "0 Kristalle",
                    "1": "1 Kristall",
                    "2": "2 Kristalle",
                    "3": "3 Kristalle",
                    "4": "4 Kristalle",
                    "5": "5 Kristalle",
                    "6": "6 Kristalle",
                    "7": "7 Kristalle",
                    "random": "Zufällig"
                }
            },
            "ganon_open": {
                "title": "Ganon verwundbar machen",
                "options": {
                    "0": "0 Kristalle",
                    "1": "1 Kristall",
                    "2": "2 Kristalle",
                    "3": "3 Kristalle",
                    "4": "4 Kristalle",
                    "5": "5 Kristalle",
                    "6": "6 Kristalle",
                    "7": "7 Kristalle",
                    "random": "Zufällig"
                }
            },
            "gameplay": {
                "title": "Gameplay"
            },
            "world_state": {
                "title": "Zustand der Welt",
                "options": {
                    "standard": "Standard",
                    "open": "Offen",
                    "inverted": "Invertiert",
                    "retro": "Retro"
                }
            },
            "entrance_shuffle": {
                "title": "Entrance Shuffle",
                "options": {
                    "none": "Keine",
                    "simple": "Simpel",
                    "restricted": "Beschränkt",
                    "full": "Voll",
                    "crossed": "Gekreuzt",
                    "insanity": "Wahnsinn"
                }
            },
            "boss_shuffle": {
                "title": "Boss Shuffle",
                "options": {
                    "none": "Keine",
                    "simple": "Simpel",
                    "full": "Voll",
                    "random": "Zufällig"
                }
            },
            "enemy_shuffle": {
                "title": "Enemy Shuffle",
                "options": {
                    "none": "Keine",
                    "shuffled": "Gemischt",
                    "random": "Zufällig"
                }
            },
            "hints": {
                "title": "Hinweise",
                "options": {
                    "on": "An",
                    "off": "Aus"
                }
            },
            "weapons": {
                "title": "Schwerter",
                "options": {
                    "randomized": "Zufällig",
                    "assured": "Garantiert",
                    "vanilla": "Vanilla",
                    "swordless": "Schwertlos"
                }
            },
            "item_pool": {
                "title": "Item Pool",
                "options": {
                    "easy": "Einfach",
                    "normal": "Normal",
                    "hard": "Schwer",
                    "expert": "Experte",
                    "crowd_control": "Crowd Control"
                },
                "crowd_control_warning": "<sup>*</sup> Diese Erweiterung ist für die Verwundung mit Twitches Crowd Control Erweiterung gedacht. Für mehr Info´s: <a href=\"https://crowdcontrol.live/\" target=\"_blank\" rel=”noopener noreferrer”>https://crowdcontrol.live/</a>"
            },
            "item_functionality": {
                "title": "Gegendstands Funktionalität",
                "options": {
                    "easy": "Einfach",
                    "normal": "Normal",
                    "hard": "Schwer",
                    "expert": "Experte"
                }
            },
            "enemy_damage": {
                "title": "Gegnerschaden",
                "options": {
                    "default": "Default",
                    "shuffled": "Gemischt",
                    "random": "Zufällig"
                }
            },
            "enemy_health": {
                "title": "Gegnerleben",
                "options": {
                    "default": "Default",
                    "easy": "Einfach",
                    "hard": "Schwer",
                    "expert": "Experte"
                }
            },
            "spoiler": {
                "title": "Spoilers",
                "options": {
                    "off": "Disabled",
                    "on": "Enabled",
                    "generate": "Nur bei Generieren"
                }
            },
            "generate": {
                "race": "Generiere ROM für Rennen",
                "race_warning": "<span class=\"running-now\">Spoilerfrei</span>",
                "spoiler_race": "ROM für Spoiler Rennen",
                "casual": "Generiere ROM",
                "back": "Ändere Einstellung",
                "forward": "Generiertes Spiel anzeigen",
                "regenerate": "Erneut erstellen",
                "regenerate_tooltip": "Erstellt ein neues Spiel mit den gleichen Einstellungen",
                "generating": "Am erstellen..."
            },
            "details": {
                "title": "Spiel Details",
                "save_spoiler": "Speichere Spoiler",
                "save_rom": "Speichere ROM"
            },
            "variation": {
                "title": "Variation"
            },
            "difficulty": {
                "title": "Schwierigkeitsgrad",
                "options": {
                    "easy": "Einfach",
                    "normal": "Normal",
                    "hard": "Schwer",
                    "expert": "Experte",
                    "insane": "Wahnsinnig",
                    "crowdControl": "Crowd Control"
                }
            }
        },
        "error": {
            "title": "Fehler",
            "429": "Auch wenn wir schätzen das du einen haufen Spiele generierst, andere Leute möchten dies aber auch. Bitte kommen später wieder wenn du mehr generieren möchtest.",
            "failed_generation": "Fehler beim erstellen :(",
            "bad_file": "Datei nicht erkannt",
            "quota_exceeded_error": "Lokaler Cache Speicher ist voll."
        },
        "rom": {
            "loader": {
                "title": "Anfangen",
                "file_select": "ROM Datei auswählen",
                "content": "<ol><li>Wähle die ROM Datei und lade sie ihn den Browser (Bitte nutze die <strong>Zelda no Densetsu: Kamigami no Triforce v1.0</strong> ROM mit einer .smc oder .sfc Endung)</li><li>Wähle die <a href=\"/de/options\">Spieloptionen</a> um auszuwählen wie Zufällig dein Spiel sein soll</li><li>Klicke Generiere ROM für Rennen</li><li>Dann speichere deine ROM und fang an zu spielen</li></ol>"
            },
            "info": {
                "spoilerwarning": "WARNUNG: Der Ersteller dieses Spiel hat den Spoiler Log angesehen.",
                "mystery": "Dies ist ein geheimnissvolles Spiel. Die Einstellungen sind unbekannt und müssen beim Spielen herausgefunden werden!",
                "logic": "Vorausgesetzte Glitches",
                "accessibility": "Zugänglichkeit",
                "build": "ROM build",
                "difficulty": "Schwierigkeitsgrad",
                "variation": "Variation",
                "shuffle": "Entrance Shuffle",
                "mode": "Zustand der Welt",
                "weapons": "Schwerter",
                "goal": "Ziel",
                "permalink": "Permalink",
                "special": "Spezial",
                "notes": "Notizen",
                "generated": "Erstellt"
            },
            "settings": {
                "heart_speed": "Geschwindigkeit des Warnungston bei wenig Leben",
                "heart_speeds": {
                    "off": "Aus",
                    "double": "Doppelte Geschwindigkeit",
                    "normal": "Normale Geschwindigkeit",
                    "half": "Halbe Geschwindigkeit",
                    "quarter": "Viertel Geschwindigkeit"
                },
                "menu_speed": "Menü Geschwindigkeit",
                "menu_speeds": {
                    "instant": "Instant",
                    "fast": "Schnell",
                    "normal": "Normal",
                    "slow": "Langsam"
                },
                "heart_color": "Farbe der Herzen",
                "heart_colors": {
                    "blue": "Blau",
                    "green": "Grün",
                    "red": "Rot",
                    "yellow": "Gelb",
                    "random": "Zufällig"
                },
                "play_as": "Spiele als",
                "sprite_file_select": ".zspr Datei auswählen",
                "msu1resume": "MSU-1 Fortsetzung",
                "shuffle_sfx": "Zufalls-SFX",
                "music": "Hintergrundmusik",
                "music_info": "(setze zu \"Keine\" für <a href=\"https://alttprlinks.page.link/SjiP\" target=\"_blank\" rel=\"noopener noreferrer\">MSU-1 Support</a>)",
                "quickswap": "Gegenstand Schnellwechsel",
                "palette_shuffle": "Palette Shuffle",
                "race_warning": "Funktioniert nicht in einer ROM für Rennen",
                "reduce_flashing": "Blitzeffekte reduzieren",
                "reduce_flashing_warning": "Diese Option reduziert die Intensität von Blitzeffekten. Individuelle Lichtempfindlichkeitsreaktionen sind nicht ganz ausgeschlossen."
            }
        },
        "customizer": {
            "settings": {
                "timers": {
                    "off": "Aus",
                    "stopwatch": "Stoppuhr",
                    "countdown-ohko": "Countdown OHKO",
                    "countdown-continue": "Countdown fortführen",
                    "countdown-stop": "Countdown stopp"
                },
                "dungeon_count": {
                    "off": "Aus",
                    "on": "Immer an",
                    "pickup": "Beim aufheben des Kompass"
                }
            },
            "glitches": {
                "canBombJump": {
                    "title": "Bomb Jump",
                    "description": "Es kann vorausgesetz werden, dass man mit Bomben über Abgründe springt."
                },
                "canBootsClip": {
                    "title": "Boots Clip",
                    "description": "Wenn man die Pegasusstiefel besitzt könnte es vorausgesetz werden, dass man mit ihnen durch Wände clippt in der Overworld."
                },
                "canBunnyRevive": {
                    "title": "Bunny Revive",
                    "description": "Es kann vorausgesetz werden, dass man die Wiederbelebungs/Feenmechanik ausnutzt um Link zu werden ohne Mondperle in der Overworld."
                },
                "canBunnySurf": {
                    "title": "Bunny Surf",
                    "description": "Es kann vorausgesetz werden, dass man in der Hasenform auf dem Wassser läuft."
                },
                "canDungeonRevive": {
                    "title": "Dungeon Revive",
                    "description": "Es kann vorausgesetz werden, dass man die Wiederbelebungsmechanik nutzt um Link zu werden in einem Palast um Gegenstände aufzusammeln."
                },
                "canFakeFlipper": {
                    "title": "Fake Flipper",
                    "description": "Es kann vorausgesetz werden, dass man Fake Flipper nutzt um an gewissen Gegenstände zu kommen."
                },
                "canMirrorClip": {
                    "title": "Mirror Clip",
                    "description": "Es kann vorausgesetz werden, dass man Mirror Bounce ausnutzt um außerhalb der Spielwelt zu gelangen."
                },
                "canMirrorWrap": {
                    "title": "Mirror Wrap",
                    "description": "Es kann vorausgesetz werden, dass man den Spiegel nutzt um den Spielbildschirm zu scrollen damit man an einen anderen Ort kommt."
                },
                "canTransitionWrapped": {
                    "title": "Screenwrap Transition",
                    "description": "Es kann vorausgesetz werden, dass man einen Oberwelt Szenen Übergang trifft, während man außerhalb der aktuellen Oberwelt Szene ist, um den Spielbildschirm zu scrollen."
                },
                "canOneFrameClipOW": {
                    "title": "One Frame Clip (overworld)",
                    "description": "Du willst das hier nicht! Glaub mir."
                },
                "canOneFrameClipUW": {
                    "title": "One Frame Clip (underworld)",
                    "description": "Use 1 Frame Movement to clip between rooms of the underworld."
                },
                "canOWYBA": {
                    "title": "YBA (overworld)",
                    "description": "Es kann vorausgesetz werden, dass man Flaschen in der Overworld nutzt um damit an einen Ort zu telepotieren."
                },
                "canSuperBunny": {
                    "title": "Super Bunny",
                    "description": "Es kann vorausgesetz werden, dass man Super Bunny aktiviert um an gewisse Orte zu kommen."
                },
                "canSuperSpeed": {
                    "title": "Super Speed",
                    "description": "Es kann vorausgesetz werden, dass man Super Speed nutzt um durch die Ecken der Overworld durchzulaufen."
                },
                "canWaterFairyRevive": {
                    "title": "Water Fairy Revive",
                    "description": "Die vorbereitung hierfür ist einfach nur dumm und brauch viel zu viele Gegenstände."
                },
                "canWaterWalk": {
                    "title": "Water walk",
                    "description": "Es kann vorausgesetz werden, dass man auf Wasser läuft."
                },
                "noLogic": {
                    "title": "Disable all logic checks",
                    "description": "Wenn man diese Option aktiviert werden alle unteren Optionen ignoriert."
                }
            }
        },
        "item": {
            "Random": "Zufällig",
            "BottleWithRandom": "Flasche (Zufällig)",
            "Nothing": "Nichts",
            "UncleSword": "Progressives Schwert",
            "L1Sword": "Schwert des Onkels",
            "L1SwordAndShield": "Schwert und Schild des Onkels",
            "L2Sword": "Master-Schwert",
            "MasterSword": "Master-Schwert",
            "L3Sword": "Gehärtetes Schwert",
            "L4Sword": "Goldenes Schwert",
            "BlueShield": "Schild des Onkels",
            "RedShield": "Rotes Schild",
            "MirrorShield": "Spiegelschild",
            "FireRod": "Feuerstab",
            "IceRod": "Eisstab",
            "Hammer": "Hammer",
            "Hookshot": "Enterharken",
            "Bow": "Bogen",
            "Boomerang": "Blauer Bumerang",
            "Powder": "Magisches Pulver",
            "Bee": "Biene",
            "Bombos": "Bombos-Medaillon",
            "Ether": "Ether-Medaillon",
            "Quake": "Quake-Medaillon",
            "Lamp": "Lampe",
            "Shovel": "Schaufel",
            "OcarinaInactive": "Flöte",
            "CaneOfSomaria": "Somaria Stab",
            "Bottle": "Flasche (Leer)",
            "PieceOfHeart": "Herzteil",
            "CaneOfByrna": "Byrna Stab",
            "Cape": "Magischer Umhang",
            "MagicMirror": "Magischer Spiegel",
            "PowerGlove": "Krafthandschuhe",
            "TitansMitt": "Titanenhandschuhe",
            "BookOfMudora": "Buch Mudora",
            "Flippers": "Schwimmflossen",
            "MoonPearl": "Mondperle",
            "BugCatchingNet": "Schmetterlingsnetz",
            "BlueMail": "Blaue Rüstung",
            "RedMail": "Rote Rüstung",
            "Key": "Schlüssel",
            "Compass": "Kompass",
            "HeartContainerNoAnimation": "Herzcontainer (keine Animation)",
            "Bomb": "Eine Bombe",
            "ThreeBombs": "Drei Bomben",
            "Mushroom": "Pilz",
            "RedBoomerang": "Magischer Bumerang",
            "BottleWithRedPotion": "Flasche (Rotes Elixier)",
            "BottleWithGreenPotion": "Flasche (Grünes Elixier)",
            "BottleWithBluePotion": "Flasche (Blaues Elixier)",
            "RedPotion": "Rotes Elixier",
            "GreenPotion": "Grünes Elixier",
            "BluePotion": "Blaues Elixier",
            "TenBombs": "Zehn Bomben",
            "BigKey": "Großer Schlüssel",
            "Map": "Dungeon-Karte",
            "OneRupee": "Ein Rubin",
            "FiveRupees": "Fünf Rubine",
            "TwentyRupees": "Zwanzig Rubine",
            "PendantOfCourage": "Amulett des Mutes",
            "PendantOfWisdom": "Amulett der Weisheit",
            "PendantOfPower": "Amulett der Stärke",
            "BowAndArrows": "Pfeil und Bogen",
            "BowAndSilverArrows": "Silberpfeil und Bogen",
            "BottleWithBee": "Flasche (Biene)",
            "BottleWithFairy": "Flasche (Fee)",
            "BossHeartContainer": "Herzcontainer",
            "HeartContainer": "Herzcontainer der Kathedrale",
            "OneHundredRupees": "Einhundert Rubine",
            "FiftyRupees": "Fünfzig Rubine",
            "Heart": "Kleines Herz",
            "Arrow": "Ein Pfeil",
            "ShopArrow": "Arrows",
            "TenArrows": "Zehn Pfeile",
            "SmallMagic": "Kleine Magie",
            "ThreeHundredRupees": "Dreihundert Rubine",
            "TwentyRupees2": "Zwanzig Rubine",
            "BottleWithGoldBee": "Flasche (Goldene Biene)",
            "OcarinaActive": "Flöte (Aktiviert)",
            "PegasusBoots": "Pegasus-Stiefel",
            "BombUpgrade5": "Bomben Upgrade (+5)",
            "BombUpgrade10": "Bomben Upgrade (+10)",
            "BombUpgrade50": "Bomben Upgrade (+50)",
            "ArrowUpgrade5": "Pfeil Upgrade (+5)",
            "ArrowUpgrade10": "Pfeil Upgrade (+10)",
            "ArrowUpgrade70": "Pfeil Upgrade (+70)",
            "HalfMagic": "Halbe Magie",
            "QuarterMagic": "Viertel Magie",
            "Programmable1": "Programmierbar 1",
            "Programmable2": "Programmierbar 2",
            "Programmable3": "Programmierbar 3",
            "SilverArrowUpgrade": "Silberpfeil Upgrade",
            "Rupoor": "Rupoor",
            "RedClock": "Rote Uhr",
            "BlueClock": "Blaue Uhr",
            "GreenClock": "Grüne Uhr",
            "ProgressiveSword": "Progressives Schwert",
            "ProgressiveShield": "Progressives Schild",
            "ProgressiveArmor": "Progressive Rüstung",
            "ProgressiveGlove": "Progressive Handschuhe",
            "singleRNG": "Einzigartiger RNG Gegenstand",
            "multiRNG": "Nicht einzigartiger RNG Gegenstand",
            "ProgressiveBow": "Progressiver Bogen",
            "Triforce": "Triforce",
            "PowerStar": "Power-Stern",
            "TriforcePiece": "Triforce-Splitter",
            "MapLW": "Lichtwelt-Karte",
            "MapDW": "Schattenwelt-Karte",
            "MapA2": "Karte von Ganons Turm",
            "MapD7": "Karte vom Schildkrötenfelsen",
            "MapD4": "Karte von Blinds Versteck",
            "MapP3": "Karte von Heras Turm",
            "MapD5": "Karte vom Eispalast",
            "MapD3": "Karte vom Skelettwald",
            "MapD6": "Karte vom Wüstenseepalast",
            "MapD1": "Karte vom Palast der Dunkelheit",
            "MapD2": "Karte vom Sumpfpalast",
            "MapA1": "Karte von Agahnims Turm",
            "MapP2": "Karte vom Wüstenpalast",
            "MapP1": "Karte vom Ostpalast",
            "MapH1": "Karte von Schloss Hyrule",
            "MapH2": "Karte der Kanalisation",
            "CompassA2": "Kompass von Ganons Turm",
            "CompassD7": "Kompass vom Schildkrötenfelsen",
            "CompassD4": "Kompass von Blinds Versteck",
            "CompassP3": "Kompass von Heras Turm",
            "CompassD5": "Kompass vom Eispalast",
            "CompassD3": "Kompass vom Skelettwald",
            "CompassD6": "Kompass vom Wüstenseepalast",
            "CompassD1": "Kompass vom Palast der Dunkelheit",
            "CompassD2": "Kompass vom Sumpfpalast",
            "CompassA1": "Kompass von Agahnims Turm",
            "CompassP2": "Kompass vom Wüstenpalast",
            "CompassP1": "Kompass vom Ostpalast",
            "CompassH1": "Kompass von Schloss Hyrule",
            "CompassH2": "Kompass der Kanalisation",
            "BigKeyA2": "Großer Schlüssel von Ganons Turm",
            "BigKeyD7": "Großer Schlüssel vom Schildkrötenfelsen ",
            "BigKeyD4": "Großer Schlüssel von Blinds Versteck",
            "BigKeyP3": "Großer Schlüssel von Heras Turm",
            "BigKeyD5": "Großer Schlüssel vom Eispalast",
            "BigKeyD3": "Großer Schlüssel vom Skelettwald",
            "BigKeyD6": "Großer Schlüssel vom Wüstenseepalast",
            "BigKeyD1": "Großer Schlüssel vom Palast der Dunkelheit",
            "BigKeyD2": "Großer Schlüssel vom Sumpfpalast",
            "BigKeyA1": "Großer Schlüssel von Agahnims Turm",
            "BigKeyP2": "Großer Schlüssel vom Wüstenpalast",
            "BigKeyP1": "Großer Schlüssel vom Ostpalast",
            "BigKeyH1": "Großer Schlüssel von Schloss Hyrule",
            "BigKeyH2": "Großer Schlüssel der Kanalisation",
            "KeyH2": "Kleiner Schlüssel der Kanalisation",
            "KeyH1": "Kleiner Schlüssel von Schloss Hyrule",
            "KeyP1": "Kleiner Schlüssel vom Ostpalast",
            "KeyP2": "Kleiner Schlüssel vom Wüstenpalast",
            "KeyA1": "Kleiner Schlüssel von Agahnims Turm",
            "KeyD2": "Kleiner Schlüssel vom Sumpfpalast",
            "KeyD1": "Kleiner Schlüssel vom Palast der Dunkelheit",
            "KeyD6": "Kleiner Schlüssel vom Wüstenseepalast",
            "KeyD3": "Kleiner Schlüssel vom Skelettwald",
            "KeyD5": "Kleiner Schlüssel vom Eispalast",
            "KeyP3": "Kleiner Schlüssel von Heras Turm",
            "KeyD4": "Kleiner Schlüssel von Blinds Versteck",
            "KeyD7": "Kleiner Schlüssel vom Schildkrötenfelsen",
            "KeyA2": "Kleiner Schlüssel von Ganons Turm",
            "KeyGK": "Generischer kleiner Schlüssel",
            "Crystal1": "Kristall 1",
            "Crystal2": "Kristall 2",
            "Crystal3": "Kristall 3",
            "Crystal4": "Kristall 4",
            "Crystal5": "Kristall 5",
            "Crystal6": "Kristall 6",
            "Crystal7": "Kristall 7",
            "RescueZelda": "Rette Zelda",
            "DefeatAgahnim": "Besiege Agahnim",
            "BigRedBomb": "Große rote Bombe",
            "DefeatAgahnim2": "Besiege Agahnim 2",
            "DefeatGanon": "Besiege Ganon",
            "ChocoboEgg": "Chocobo Ei",
            "NoSlipBoots": "Winterstiefel",
            "WinterCoat": "Wintermantel",
            "Duck": "Ente",
            "Reindeer1": "Dasher",
            "Reindeer2": "Dancer",
            "Reindeer3": "Prancer",
            "Reindeer4": "Vixen",
            "Reindeer5": "Comet",
            "Reindeer6": "Cupid",
            "Reindeer7": "Donner",
            "Reindeer8": "Blitzen",
            "Gift1": "Geschenk 1",
            "Gift2": "Geschenk 2",
            "Gift3": "Geschenk 3",
            "Gift4": "Geschenk 4",
            "Gift5": "Geschenk 5",
            "Gift6": "Geschenk 6",
            "Gift7": "Geschenk 7",
            "Coal1": "Kohle",
            "Coal2": "Kohle",
            "GoldenTicket": "Golden Ticket",
            "Armos Knights": "Armos Knights",
            "Lanmolas": "Lanmolas",
            "Moldorm": "Moldorm",
            "Helmasaur King": "Helmasaur King",
            "Arrghus": "Arrghus",
            "Mothula": "Mothula",
            "Blind": "Blind",
            "Kholdstare": "Kholdstare",
            "Vitreous": "Vitreous",
            "Trinexx": "Trinexx",
            "Agahnim": "Agahnim",
            "Agahnim 2": "Agahnim 2",
            "Ganon": "Ganon",
            "Test": "Gegenstand fürs testen"
        },
        "entrance": {
            "title": "Entrance Randomizer",
            "switch": {
                "item": "Wechsele zum Item Randomizer"
            },
            "rom": {
                "options": "ROM Optionen"
            },
            "difficulty": {
                "title": "Schwierigkeit",
                "options": {
                    "easy": "Einfach",
                    "normal": "Mittel",
                    "hard": "Schwer",
                    "expert": "Experte",
                    "insane": "Wahnsinnig"
                }
            },
            "goal": {
                "title": "Ziel",
                "options": {
                    "ganon": "Besiege Ganon",
                    "crystals": "Kristalle",
                    "dungeons": "Alle Dungeons",
                    "pedestal": "Master-Schwert Sockel",
                    "triforcehunt": "Triforce Teile"
                }
            },
            "logic": {
                "title": "Logik",
                "options": {
                    "NoGlitches": "Keine Glitches"
                }
            },
            "mode": {
                "title": "Zustand",
                "options": {
                    "swordless": "Schwertlos",
                    "open": "Offen"
                }
            },
            "shuffle": {
                "title": "Mischung",
                "options": {
                    "simple": "Simpel",
                    "restricted": "Beschränkt",
                    "full": "Voll",
                    "crossed": "Gekreuzt",
                    "insanity": "Wahnsinn"
                }
            },
            "variation": {
                "title": "Variation",
                "options": {
                    "none": "Keine",
                    "timed-race": "Zeitrennen",
                    "timed-ohko": "Zeitlimit bis OHKO",
                    "ohko": "OHKO",
                    "triforce-hunt": "Triforce-Splitter Jagd",
                    "key-sanity": "Keysanity",
                    "retro": "Retro"
                }
            },
            "generate": {
                "race": "Generiere ROM für Rennen",
                "spoiler_race": "ROM für Spoiler Rennen",
                "casual": "Generiere ROM"
            },
            "details": {
                "title": "Spiele Details",
                "save_spoiler": "Speichere Spoiler",
                "save_rom": "Speichere ROM"
            }
        }
    },
    "en": {
        "enemizer": {
            "title": "Enemizer",
            "enable": "Enable Enemizer",
            "disable": "Disable Enemizer",
            "enemy_health": {
                "title": "Enemy Health",
                "options": [
                    "Default",
                    "Easy (1-4 hp)",
                    "Normal (2-15 hp)",
                    "Hard (2-30 hp)",
                    "Brick Wall (4-50 hp)"
                ]
            },
            "enemy_damage": {
                "title": "Enemy Damage",
                "options": {
                    "off": "Default",
                    "shuffle": "Shuffled",
                    "chaos": "Chaos"
                }
            },
            "bosses": {
                "title": "Boss Shuffle",
                "options": {
                    "off": "Off",
                    "basic": "Simple",
                    "normal": "Full",
                    "chaos": "Chaos"
                }
            },
            "palette_shuffle": "Palette Shuffle",
            "pot_shuffle": "Pot Shuffle",
            "enemy_shuffle": "Enemy Shuffle"
        },
        "randomizer": {
            "title": "Randomizer",
            "preset": {
                "title": "Select Preset",
                "customize": "Customize",
                "options": {
                    "default": "Default",
                    "trinity": "Trinity",
                    "bombs_only": "Bomb-Only Mode",
                    "doors": "Dungeon Shuffle",
                    "ow_basic": "Basic Overworld Shuffle",
                    "ow_advanced": "Advanced Overworld Shuffle",
                    "beginner": "Beginner",
                    "veetorp": "OWG (Veetorp’s Favorite)",
                    "crosskeys": "Crosskeys",
                    "quick": "Super Quick",
                    "quick_mixed": "Super Quick Mixed",
                    "nightmare": "Nightmare",
                    "tournament": "Tournament",
                    "everything": "Everything Shuffle",
                    "custom": "Custom"
                }
            },
            "placement": {
                "title": "Item Placement"
            },
            "item_placement": {
                "title": "Item Placement",
                "options": {
                    "basic": "Basic",
                    "advanced": "Advanced"
                }
            },
            "dungeon_items": {
                "title": "Dungeon Item Shuffle",
                "options": {
                    "standard": "Standard",
                    "b": "Big Keys",
                    "mc": "Maps/Compasses",
                    "mcs": "Maps/Compasses/Small Keys",
                    "full": "Full"
                }
            },
            "boss_items": {
                "title": "Boss Items",
                "options": {
                    "any": "No Restriction",
                    "nondungeon": "No Dungeon Items"
                }
            },
            "drop_shuffle": {
                "title": "Enemy Drop Shuffle",
                "options": {
                    "on": "On",
                    "off": "Off"
                }
            },
            "bonk_shuffle": {
                "title": "Bonk Shuffle",
                "options": {
                    "on": "On",
                    "off": "Off"
                }
            },
            "pottery_shuffle": {
                "title": "Pottery Shuffle",
                "options": {
                    "none": "Vanilla",
                    "lottery": "Lottery",
                    "nonempty": "Non-Empty",
                    "keys": "Keys",
                    "dungeon": "Dungeon",
                    "cave": "Cave",
                    "cavekeys": "Caves + Keys",
                    "reduced": "Reduced",
                    "clustered": "Clustered"
                }
            },
            "accessibility": {
                "title": "Accessibility",
                "options": {
                    "items": "100% Inventory",
                    "locations": "100% Locations",
                    "none": "Beatable Only"
                }
            },
            "glitches_required": {
                "title": "Glitches Required",
                "options": {
                    "none": "None",
                    "overworld_glitches": "Overworld Glitches",
                    "hybrid_major_glitches": "Hybrid Major Glitches",
                    "major_glitches": "Major Glitches",
                    "no_logic": "No Logic"
                },
                "glitch_warning": "These settings require knowledge of Major Glitches<sup>**</sup>"
            },
            "goal": {
                "title": "Goal",
                "options": {
                    "ganon": "Defeat Ganon",
                    "fast_ganon": "Fast Ganon",
                    "dungeons": "All Dungeons",
                    "pedestal": "Master Sword Pedestal",
                    "triforce-hunt": "Triforce Pieces",
                    "trinity": "Trinity",
                    "ambroz1a": "Ambroz1a",
                    "ganonhunt": "Ganonhunt",
                    "completionist": "Completionist"
                }
            },
            "tower_open": {
                "title": "Open Tower",
                "options": {
                    "0": "0 Crystals",
                    "1": "1 Crystal",
                    "2": "2 Crystals",
                    "3": "3 Crystals",
                    "4": "4 Crystals",
                    "5": "5 Crystals",
                    "6": "6 Crystals",
                    "7": "7 Crystals",
                    "random": "Random"
                }
            },
            "ganon_open": {
                "title": "Ganon Vulnerable",
                "options": {
                    "0": "0 Crystals",
                    "1": "1 Crystal",
                    "2": "2 Crystals",
                    "3": "3 Crystals",
                    "4": "4 Crystals",
                    "5": "5 Crystals",
                    "6": "6 Crystals",
                    "7": "7 Crystals",
                    "random": "Random",
                    "low_random": "Low Random (1-4)"
                }
            },
            "ganon_item": {
                "title": "Ganon Vulnerability Item",
                "options": {
                    "default": "Default",
                    "random": "Random",
                    "arrow": "Silver Arrows",
                    "boomerang": "Boomerang",
                    "hookshot": "Hookshot",
                    "bomb": "Bombs",
                    "powder": "Magic Powder",
                    "fire_rod": "Fire Rod",
                    "ice_rod": "Ice Rod",
                    "bombos": "Bombos",
                    "ether": "Ether",
                    "quake": "Quake",
                    "hammer": "Hammer",
                    "bee": "Bee",
                    "somaria": "Cane of Somaria",
                    "byrna": "Cane of Byrna"
                }
            },
            "gameplay": {
                "title": "Gameplay"
            },
            "overworld_shuffle": {
                "title": "Overworld Shuffle"
            },
            "world_state": {
                "title": "World State",
                "options": {
                    "standard": "Standard",
                    "open": "Open",
                    "inverted": "Inverted",
                    "retro": "Retro"
                }
            },
            "entrance_shuffle": {
                "title": "Entrance Shuffle",
                "options": {
                    "none": "None",
                    "simple": "Simple",
                    "restricted": "Restricted",
                    "full": "Full",
                    "crossed": "Crossed",
                    "swapped": "Swapped",
                    "insanity": "Non-Symmetric",
                    "lite": "Lite",
                    "lean": "Lean",
                    "dungeonssimple": "Simple (Dungeons Only)",
                    "dungeonsfull": "Full (Dungeons Only)"
                }
            },
            "doors_warning": "Seeds with door shuffle or drop shuffle enabled could take a long time to generate and may sometimes fail, but should succeed after a retry or two if necessary.",
            "door_shuffle": {
                "title": "Door Shuffle",
                "options": {
                    "vanilla": "None",
                    "partitioned": "Partitioned",
                    "basic": "Basic",
                    "crossed": "Crossed"
                }
            },
            "door_intensity": {
                "title": "Door Shuffle Intensity",
                "options": {
                    "1": "1: Normal",
                    "2": "2: Open Edges",
                    "3": "3: Lobbies"
                }
            },
            "door_type_mode": {
                "title": "Door Shuffle Type Mode",
                "options": {
                    "original": "Original",
                    "big": "Big",
                    "all": "All",
                    "chaos": "Chaos"
                }
            },
            "trap_door_mode": {
                "title": "Trap Door Mode",
                "options": {
                    "vanilla": "Vanilla",
                    "optional": "Optional",
                    "boss": "Boss",
                    "oneway": "One-Way"
                }
            },
            "decouple_doors": {
                "title": "Decouple Doors",
                "options": {
                    "on": "On",
                    "off": "Off"
                }
            },
            "ow_shuffle": {
                "title": "Overworld Layout Shuffle",
                "options": {
                    "vanilla": "None",
                    "parallel": "Parallel",
                    "full": "Full"
                }
            },
            "ow_crossed": {
                "title": "Overworld Crossed",
                "options": {
                    "vanilla": "None",
                    "polar": "Polar",
                    "grouped": "Grouped",
                    "limited": "Limited",
                    "chaos": "Chaos"
                }
            },
            "ow_keep_similar": {
                "title": "Overworld Keep Similar",
                "options": {
                    "on": "On",
                    "off": "Off"
                }
            },
            "ow_mixed": {
                "title": "Overworld Tile Flip",
                "options": {
                    "off": "None",
                    "on": "Mixed"
                }
            },
            "ow_flute_shuffle": {
                "title": "Flute Shuffle",
                "options": {
                    "vanilla": "None",
                    "balanced": "Balanced",
                    "random": "Random"
                }
            },
            "ow_whirlpool_shuffle": {
                "title": "Whirlpool Shuffle",
                "options": {
                    "vanilla": "None",
                    "shuffled": "Shuffled"
                }
            },
            "shopsanity": {
                "title": "Shop Shuffle",
                "options": {
                    "on": "On",
                    "off": "Off"
                }
            },
            "boss_shuffle": {
                "title": "Boss Shuffle",
                "options": {
                    "none": "None",
                    "simple": "Simple",
                    "full": "Full",
                    "random": "Random",
                    "moldorm": "All Moldorm"
                }
            },
            "enemy_shuffle": {
                "title": "Enemy Shuffle",
                "options": {
                    "none": "None",
                    "shuffled": "Shuffled",
                    "killable": "Killable",
                    "random": "Random",
                    "moldorms": "Moldorms"
                },
                "moldorm_warning": "Are you sure you really want this?",
                "killable_warning": "Killable Enemy Shuffle is still under development; expect occasional graphics irregularities."
            },
            "hints": {
                "title": "Hints",
                "options": {
                    "on": "On",
                    "off": "Off"
                }
            },
            "weapons": {
                "title": "Swords",
                "options": {
                    "randomized": "Randomized",
                    "assured": "Assured",
                    "vanilla": "Vanilla",
                    "swordless": "Swordless",
                    "swordless_b": "Swordless w/ Items on B",
                    "bombs": "Bomb-Only",
                    "assured_bombs": "Bomb-Only (Starting Bombs)",
                    "byrna": "Byrna Mode",
                    "assured_byrna": "Byrna Mode (Starting Cane)",
                    "somaria": "Somaria Mode",
                    "assured_somaria": "Somaria Mode (Starting Cane)",
                    "cane": "Canes Mode",
                    "pseudo": "Pseudo-Swords",
                    "assured_pseudo": "Assured Pseudo-Swords",
                    "bees": "Bee Mode",
                    "bugnet": "Bug Net Mode",
                    "assured_bugnet": "Bug Net Mode (Starting Bug Net)"
                },
                "bees_warning": "Bee Mode is only partially implemented, and not compatible with entrance, door, or overworld shuffle."
            },
            "item_pool": {
                "title": "Item Pool",
                "options": {
                    "easy": "Easy",
                    "normal": "Normal",
                    "hard": "Hard",
                    "expert": "Expert",
                    "crowd_control": "Crowd Control"
                },
                "crowd_control_warning": "<sup>*</sup> This setting is meant to be used with the Crowd Control Twitch extension. find out more: <a href=\"https://crowdcontrol.live/\" target=\"_blank\" rel=”noopener noreferrer”>https://crowdcontrol.live/</a>"
            },
            "item_functionality": {
                "title": "Item Functionality",
                "options": {
                    "easy": "Easy",
                    "normal": "Normal",
                    "hard": "Hard",
                    "expert": "Expert"
                }
            },
            "starting_flute": {
                "title": "Starting Flute",
                "options": {
                    "off": "Off",
                    "starting": "Starting Flute (Pre-Activated)"
                }
            },
            "starting_boots": {
                "title": "Starting Boots",
                "options": {
                    "off": "Off",
                    "pseudo": "Pseudoboots",
                    "starting": "Starting Boots"
                }
            },
            "enemy_damage": {
                "title": "Enemy Damage",
                "options": {
                    "default": "Default",
                    "shuffled": "Shuffled",
                    "random": "Random"
                }
            },
            "enemy_health": {
                "title": "Enemy Health",
                "options": {
                    "default": "Default",
                    "easy": "Easy",
                    "hard": "Hard",
                    "expert": "Expert"
                }
            },
            "spoiler": {
                "title": "Spoilers",
                "options": {
                    "off": "Disabled",
                    "on": "Enabled",
                    "generate": "Only on Generate",
                    "mystery": "Mystery (settings hidden)"
                }
            },
            "generate": {
                "race": "Generate Race ROM",
                "race_warning": "Spoilers will <span class=\"running-now\">never</span> be available for this option.",
                "spoiler_race": "Generate Normal ROM",
                "casual": "Generate ROM",
                "back": "Change Settings",
                "forward": "View Generated Game",
                "regenerate": "Generate Again",
                "regenerate_tooltip": "Generate new game with same settings",
                "generating": "Generating...",
                "slow_warning": "Generation of seeds with complicated settings may take several minutes. Please be patient."
            },
            "details": {
                "title": "Game Details",
                "save_spoiler": "Save Spoiler",
                "save_rom": "Save ROM"
            },
            "variation": {
                "title": "Variation"
            },
            "difficulty": {
                "title": "Difficulty",
                "options": {
                    "easy": "Easy",
                    "normal": "Normal",
                    "hard": "Hard",
                    "expert": "Expert",
                    "insane": "Insane",
                    "crowdControl": "Crowd Control"
                }
            }
        },
        "error": {
            "title": "Error",
            "429": "While we apprecate your want to generate a lot of games, Other people would like to as well. Please come back later if you would like to generate more.",
            "failed_generation": "Failed Creating Game :(",
            "failed_host": "Failed Hosting Game :(",
            "bad_file": "File not recognized",
            "quota_exceeded_error": "Your local storage quota has been exceeded."
        },
        "sprite": {
            "Raven": "Raven",
            "Vulture": "Vulture",
            "FlyingStalfosHead": "Flying Stalfos Head",
            "Empty": "Empty",
            "PullSwitchGood": "Pull Switch (Good)",
            "PullSwitch1": "Pull Switch (Unused)",
            "PullSwitchBad": "Pull Switch (Bad)",
            "PullSwitch2": "Pull Switch (Unused)",
            "Octorok1": "Octorok (One Way)",
            "Moldorm": "Moldorm (Boss)",
            "Octorok4": "Octorok (Four Way)",
            "Chicken": "Chicken",
            "Octorok": "Octorok (?)",
            "Buzzblob": "Buzzblob",
            "Snapdragon": "Snapdragon",
            "Octoballoon": "Octoballoon",
            "OctoballoonHatchlings": "Octoballoon Hatchlings",
            "Hinox": "Hinox",
            "Moblin": "Moblin",
            "MiniHelmasaur": "Mini Helmasaur",
            "ForkGate": "Gargoyle's Domain Gate",
            "Antifairy": "Antifairy",
            "Sahasrahla": "Sahasrahla / Aginah",
            "BushHoarder": "Bush Hoarder",
            "MiniMoldorm": "Mini Moldorm",
            "Poe": "Poe",
            "Dwarves": "Dwarves",
            "WallArrow": "Arrow in wall?",
            "Statue": "Statue",
            "Weathervane": "Weathervane",
            "CrystalSwitch": "Crystal Switch",
            "SickKid": "Bug-Catching Kid",
            "Sluggula": "Sluggula",
            "PushSwitch": "Push Switch",
            "Ropa": "Ropa",
            "RedBari": "Red Bari",
            "BlueBari": "Blue Bari",
            "TalkingTree": "Talking Tree",
            "HardhatBeetle": "Hardhat Beetle",
            "Deadrock": "Deadrock",
            "Storytellers": "Storytellers",
            "BlindHistorian": "Blind Hideout attendant",
            "SweepingLady": "Sweeping Lady",
            "Multipurpose": "Multipurpose Sprite",
            "Lumberjacks": "Lumberjacks",
            "TelepathicStones": "Telepathic stones? (No idea what this actually is, likely unused)",
            "FluteBoyNotes": "Flute Boy's Notes",
            "RaceNPCs": "Race HP NPCs",
            "Person": "Person?",
            "FortuneTeller": "Fortune Teller",
            "AngryBrothers": "Angry Brothers",
            "PullForRupees": "Pull For Rupees Sprite",
            "ScaredGirl2": "Scared Girl 2",
            "Innkeeper": "Innkeeper",
            "0": "Potion  =>hop",
            "1": "Potion Shop",
            "Waterfall": "Waterfall",
            "ArrowTarget": "Arrow Target",
            "AverageMan": "Average Middle-Aged Man",
            "MagicBat": "Half Magic Bat",
            "DashItem": "Dash Item",
            "VillageKid": "Village Kid",
            "Sign": "Signs? Chicken lady also showed up / Scared ladies outside houses.",
            "RockHoarder": "Rock Hoarder",
            "TutorialSoldier": "Tutorial Soldier",
            "LightningLock": "Lightning Lock",
            "BlueSwordSoldier": "Blue Sword Soldier / Used by guards to detect player",
            "GreenSwordSoldier": "Green Sword Soldier",
            "RedSpearSoldier": "Red Spear Soldier",
            "AssaultSwordSoldier": "Assault Sword Soldier",
            "GreenSpearSoldier": "Green Spear Soldier",
            "BlueArcher": "Blue Archer",
            "GreenArcher": "Green Archer",
            "RedJavelinSolider": "Red Javelin Soldier",
            "RedJavelinSolider2": "Red Javelin Soldier 2",
            "RedBombSolider": "Red Bomb Soldiers",
            "GreenSoldierRecruit": "Green Soldier Recruits",
            "Geldman": "Geldman",
            "Rabbit": "Rabbit",
            "Popo": "Popo",
            "Popo2": "Popo 2",
            "CannonBall": "Cannon Balls",
            "Armos": "Armos",
            "KingZora": "Giant Zora",
            "ArmosKnights": "Armos Knights (Boss)",
            "Lanmolas": "Lanmolas (Boss)",
            "FireballZora": "Fireball Zora",
            "WalkingZora": "Walking Zora",
            "DesertPalaceBarrier": "Desert Palace Barriers",
            "Crab": "Crab",
            "Bird": "Birds (Haunted Grove)",
            "Squirrel": "Squirrel",
            "SparkLR": "Spark (Left to Right)",
            "SparkRL": "Spark (Right to Left)",
            "RollerV1": "Roller (vertical moving)",
            "RollerV2": "Roller (vertical moving)",
            "Roller": "Roller",
            "RollerH": "Roller (horizontal moving)",
            "Beamos": "Beamos",
            "MasterSword": "Master Sword",
            "Devalant": "Devalant (Non-shooter)",
            "DevalantShooter": "Devalant (Shooter)",
            "ShootingGalleryNPC": "Shooting Gallery Proprietor",
            "CannonBallShooterR": "Moving Cannon Ball Shooters (Right)",
            "CannonBallShooterL": "Moving Cannon Ball Shooters (Left)",
            "CannonBallShooterD": "Moving Cannon Ball Shooters (Down)",
            "CannonBallShooterU": "Moving Cannon Ball Shooters (Up)",
            "BallNChainTrooper": "Ball N' Chain Trooper",
            "CannonSoldier": "Cannon Soldier",
            "MirrorPortal": "Mirror Portal",
            "Rat": "Rat",
            "Rope": "Rope",
            "Keese": "Keese",
            "HelmasaurFireball": "Helmasaur King Fireball",
            "Leever": "Leever",
            "PondActivation": "Activator for the ponds (where you throw in items)",
            "2": "Link' => Uncle",
            "3": "Uncle / Priest",
            "RunningMan": "Running Man",
            "BottleSalesman": "Bottle Salesman",
            "Zelda": "Princess Zelda",
            "Antifairy2": "Antifairy (Alternate)",
            "VillageElder": "Village Elder",
            "Bee": "Bee Swarm",
            "Agahnim": "Agahnim",
            "AgahnimBall": "Agahnim Energy Ball",
            "Hyu": "Hyu",
            "BigSpikeTrap": "Big Spike Trap",
            "GuruguruBarCW": "Guruguru Bar (Clockwise)",
            "GuruguruBarCCW": "Guruguru Bar (Counter Clockwise)",
            "Winder": "Winder",
            "WaterTektite": "Water Tektite",
            "AntifairyCircle": "Antifairy Circle",
            "EyegoreGreen": "Green Eyegore",
            "EyegoreRed": "Red Eyegore",
            "StalfosYellow": "Yellow Stalfos",
            "Kodongos": "Kodongos",
            "Flames": "Flames",
            "Mothula": "Mothula (Boss)",
            "MothulaBeam": "Mothula's Beam",
            "SpikeTrap": "Spike Trap",
            "Gibdo": "Gibdo",
            "Arrghus": "Arrghus (Boss)",
            "ArrghusSpawn": "Arrghus spawn",
            "Terrorpin": "Terrorpin",
            "Slime": "Slime",
            "Wallmaster": "Wallmaster",
            "StalfosKnight": "Stalfos Knight",
            "Helmasaur": "Helmasaur King",
            "Bumper": "Bumper",
            "Swimmers": "Swimmers",
            "EyeLaserR": "Eye Laser (Right)",
            "EyeLaserL": "Eye Laser (Left)",
            "EyeLaserD": "Eye Laser (Down)",
            "EyeLaserU": "Eye Laser (Up)",
            "Pengator": "Pengator",
            "Kyameron": "Kyameron",
            "Wizzrobe": "Wizzrobe",
            "Tadpoles": "Tadpoles",
            "Tadpoles2": "Tadpoles",
            "Ostrich": "Ostrich (Haunted Grove)",
            "Flute": "Flute",
            "Freezor": "Freezor",
            "Kholdstare": "Kholdstare (Boss)",
            "KholdstareShell": "Kholdstare's Shell",
            "FallingIce": "Falling Ice",
            "ZazakFireball": "Zazak Fireball",
            "ZazakRed": "Red Zazak",
            "Stalfos": "Stalfos",
            "Zirro": "Bomber Flying Creatures from Darkworld",
            "Zirro2": "Bomber Flying Creatures from Darkworld",
            "Pikit": "Pikit",
            "Maiden": "Maiden",
            "Apple": "Apple",
            "LostOldMan": "Lost Old Man",
            "PipeD": "Down Pipe",
            "PipeU": "Up Pipe",
            "PipeR": "Right Pipe",
            "PipeL": "Left Pipe",
            "BeeGood": "Good Bee",
            "HylianInscription": "Hylian Inscription",
            "PurpleChest": "Thief's chest (not the one that follows you, the one that you grab from the DW smithy house)",
            "BombSalesman": "Bomb Salesman",
            "Kiki": "Kiki",
            "BlindMaiden": "Maiden following you in Blind Dungeon",
            "Monologue": "Monologue Testing Sprite",
            "FeudingFriends": "Feuding Friends on Death Mountain",
            "Whirlpool": "Whirlpool",
            "Salesman": "Salesman / chestgame guy / 300 rupee giver guy / Chest game thief",
            "Drunk": "Drunk in the inn",
            "Vitreous": "Vitreous (Large Eyeball)",
            "VitreousSmallEyeball": "Vitreous (Small Eyeball)",
            "VitreousLightning": "Vitreous' Lightning",
            "Catfish": "Monster in Lake of Ill Omen / Quake Medallion",
            "AgahnimTeleporting": "Agahnim teleporting Zelda to dark world",
            "Boulders": "Boulders",
            "Gibo": "Gibo",
            "Thief": "Thief",
            "Medusa": "Medusa",
            "YomoMedusa": "Yomo Medusa",
            "HokkuBokku": "Hokku-Bokku",
            "FairyBig": "Big Fairy who heals you",
            "Tektite": "Tektite",
            "ChainChomp": "Chain Chomp",
            "Trinexx": "Trinexx",
            "TrinexxHeadFire": "Another part of trinexx",
            "TrinexxHeadIce": "Yet another part of trinexx",
            "Blind": "Blind The Thief (Boss)",
            "Swamola": "Swamola",
            "Lynel": "Lynel",
            "BunnyBeam": "Bunny Beam",
            "FloppingFish": "Flopping Fish",
            "Stal": "Stal",
            "Landmine": "Landmine",
            "DiggingGameNPC": "Digging Game Proprietor",
            "Ganon": "Ganon",
            "GanonInvisible": "Copy of Ganon, except invincible?",
            "Heart": "Heart",
            "RupeeGreen": "Green Rupee",
            "RupeeBlue": "Blue Rupee",
            "RupeeRed": "Red Rupee",
            "BombRefill1": "Bomb Refill (1)",
            "BombRefill4": "Bomb Refill (4)",
            "BombRefill8": "Bomb Refill (8)",
            "MagicRefillSmall": "Small Magic Refill",
            "MagicRefillFull": "Full Magic Refill",
            "ArrowRefill5": "Arrow Refill (5)",
            "ArrowRefill10": "Arrow Refill (10)",
            "Fairy": "Fairy",
            "Key": "Key",
            "BigKey": "Big Key",
            "Shield": "Shield",
            "Mushroom": "Mushroom",
            "FakeMasterSword": "Fake Master Sword",
            "MagicShopDude": "Magic Shop dude / His items, including the magic powder",
            "HeartContainer": "Heart Container",
            "HeartPiece": "Heart Piece",
            "Bush": "Bushes",
            "SomariaPlatform": "Cane Of Somaria Platform",
            "Mantle": "Mantle",
            "SomariaPlatform1": "Cane of Somaria Platform (Unused)",
            "SomariaPlatform2": "Cane of Somaria Platform (Unused)",
            "SomariaPlatform3": "Cane of Somaria Platform (Unused)",
            "MedallionTablet": "Medallion Tablet"
        },
        "rom": {
            "loader": {
                "title": "Getting Started",
                "file_select": "Select ROM File",
                "content": "<ol><li>Select your ROM file and load it into the browser (Please use a <strong>Zelda no Densetsu: Kamigami no Triforce v1.0</strong> ROM with an .smc or .sfc extension)</li><li>Select the <a href=\"/en/options\">Game Options</a> for how you would like your game randomized</li><li>Click Generate Normal ROM</li><li>Then Save your ROM and get to playing</li></ol>"
            },
            "info": {
                "spoilerwarning": "WARNING: The generator of this game viewed the spoiler log.",
                "mystery": "This is a mystery game.  The settings must be discovered while you play!",
                "logic": "Glitches Required",
                "accessibility": "Accessibility",
                "build": "ROM build",
                "difficulty": "Difficulty",
                "variation": "Variation",
                "dungeon_items": "Dungeon Item Shuffle",
                "shuffle": "Entrance Shuffle",
                "door_shuffle": "Door Shuffle",
                "ow_shuffle": "Overworld Layout Shuffle",
                "ow_crossed": "Overworld Crossed",
                "ow_mixed": "Overworld Tile Flip",
                "pottery": "Pottery Shuffle",
                "enemy_shuffle": "Enemy Shuffle",
                "boss_shuffle": "Boss Shuffle",
                "mode": "World State",
                "weapons": "Swords",
                "goal": "Goal",
                "permalink": "Permalink",
                "multi_permalink": "Multiworld Permalink",
                "multi_name": "Multiworld Player Name",
                "special": "Special",
                "notes": "Notes",
                "generated": "Created"
            },
            "settings": {
                "heart_speed": "Heart Speed",
                "heart_speeds": {
                    "off": "Off",
                    "double": "Double Speed",
                    "normal": "Normal Speed",
                    "half": "Half Speed",
                    "quarter": "Quarter Speed"
                },
                "menu_speed": "Menu Speed",
                "menu_speeds": {
                    "instant": "Instant",
                    "fast": "Fast",
                    "normal": "Normal",
                    "slow": "Slow"
                },
                "heart_color": "Heart Color",
                "heart_colors": {
                    "blue": "Blue",
                    "green": "Green",
                    "red": "Red",
                    "yellow": "Yellow",
                    "random": "Random"
                },
                "play_as": "Play As",
                "sprite_file_select": "Select .zspr File",
                "msu1resume": "MSU-1 Resume",
                "shuffle_sfx": "Shuffle SFX",
                "music": "Background Music",
                "music_info": "(set to \"No\" for <a href=\"https://alttprlinks.page.link/SjiP\" target=\"_blank\" rel=\"noopener noreferrer\">MSU-1 support</a>)",
                "quickswap": "Item Quickswap",
                "palette_shuffle": "Palette Shuffle",
                "race_warning": "Does not work in Race ROMs",
                "reduce_flashing": "Reduce Flashing",
                "reduce_flashing_warning": "This option only reduces the effects of flashing. Individual photosensitivity to effects may still vary.",
                "fake_boots": "Pseudoboots",
                "ice_physics": "Ice Physics"
            }
        },
        "customizer": {
            "settings": {
                "timers": {
                    "off": "Off",
                    "stopwatch": "Stopwatch",
                    "countdown-ohko": "Countdown OHKO",
                    "countdown-continue": "Countdown Continue",
                    "countdown-stop": "Countdown Stop"
                },
                "dungeon_count": {
                    "off": "Off",
                    "on": "Always On",
                    "pickup": "On Compass Pickup"
                }
            },
            "glitches": {
                "canBombJump": {
                    "title": "Bomb Jump",
                    "description": "One may be required to Bomb jump over gaps."
                },
                "canBootsClip": {
                    "title": "Boots Clip",
                    "description": "When one has the Boots, they may be required to clip through walls in the overworld."
                },
                "canBunnyRevive": {
                    "title": "Bunny Revive",
                    "description": "One may be required to go somewhere in bunny form and abuse death/fairy revive to be Link."
                },
                "canBunnySurf": {
                    "title": "Bunny Surf",
                    "description": "One may be required to water walk in bunny state."
                },
                "canDungeonRevive": {
                    "title": "Dungeon Revive",
                    "description": "One may be required to revive as a bunny in a dungeon to collect items as Link."
                },
                "canFakeFlipper": {
                    "title": "Fake Flipper",
                    "description": "One may be required to use the fake flipper glitch to collect items."
                },
                "canMirrorClip": {
                    "title": "Mirror Clip",
                    "description": "One may be required to abuse Mirror Portal Placements to go out of bounds."
                },
                "canMirrorWrap": {
                    "title": "Mirror Wrap",
                    "description": "One may be required to use Mirror to auto scroll to a different location."
                },
                "canTransitionWrapped": {
                    "title": "Screenwrap Transition",
                    "description": "One may be required to hit a transition from outside the current overworld screen to get an auto scroll."
                },
                "canOneFrameClipOW": {
                    "title": "One Frame Clip (overworld)",
                    "description": "You don’t want this. Trust me."
                },
                "canOneFrameClipUW": {
                    "title": "One Frame Clip (underworld)",
                    "description": "Use 1 Frame Movement to clip between rooms of the underworld."
                },
                "canOWYBA": {
                    "title": "YBA (overworld)",
                    "description": "May be required to use bottles in the overworld to teleport to different locations."
                },
                "canSuperBunny": {
                    "title": "Super Bunny",
                    "description": "One may be required to activate super bunny to access locations."
                },
                "canSuperSpeed": {
                    "title": "Super Speed Clip",
                    "description": "One may be required to super speed clip through edges in the overworld."
                },
                "canWaterFairyRevive": {
                    "title": "Water Fairy Revive",
                    "description": "This setup is silly and requires a bunch of items."
                },
                "canWaterWalk": {
                    "title": "Water walk",
                    "description": "One may be required to use boots to walk on top of water."
                },
                "noLogic": {
                    "title": "Disable all logic checks",
                    "description": "When this is selected all bets are off, and nothing below matters."
                },
                "logicMode": {
                    "title": "Glitches Required ROM \"Fixes\"",
                    "description": "Set the type of ROM fixes applied.  Does not change item placement logic."
                }
            }
        },
        "multiworld": {
            "title": "Multiworld Randomizer",
            "generate": "Generate Multiworld",
            "save": "Save Multidata",
            "host": "Host Multiworld",
            "slow_warning": "Multiworld generation usually takes a long time. Please be patient.",
            "info": {
                "title": "Multiworld Details",
                "generated": "Created",
                "permalink": "Multiworld Permalink"
            }
        },
        "item": {
            "Random": "Random",
            "BottleWithRandom": "Bottle (Random)",
            "Nothing": "Nothing",
            "UncleSword": "Progressive Sword",
            "L1Sword": "Fighters Sword",
            "L1SwordAndShield": "Fighters Sword and Shield",
            "L2Sword": "Master Sword",
            "MasterSword": "Master Sword",
            "L3Sword": "Tempered Sword",
            "L4Sword": "Golden Sword",
            "BlueShield": "Fighters Shield",
            "RedShield": "Fire Shield",
            "MirrorShield": "Mirror Shield",
            "FireRod": "Fire Rod",
            "IceRod": "Ice Rod",
            "Hammer": "Hammer",
            "Hookshot": "Hookshot",
            "Bow": "Bow",
            "Boomerang": "Blue Boomerang",
            "Powder": "Magic Powder",
            "Bee": "Bee",
            "Bombos": "Bombos",
            "Ether": "Ether",
            "Quake": "Quake",
            "Lamp": "Lamp",
            "Shovel": "Shovel",
            "OcarinaInactive": "Flute",
            "CaneOfSomaria": "Cane Of Somaria",
            "Bottle": "Bottle (Empty)",
            "PieceOfHeart": "Piece Of Heart",
            "CaneOfByrna": "Cane Of Byrna",
            "Cape": "Magic Cape",
            "MagicMirror": "Magic Mirror",
            "PowerGlove": "Power Glove",
            "TitansMitt": "Titans Mitt",
            "BookOfMudora": "Book Of Mudora",
            "Flippers": "Flippers",
            "MoonPearl": "Moon Pearl",
            "BugCatchingNet": "Bug Catching Net",
            "BlueMail": "Blue Mail",
            "RedMail": "Red Mail",
            "Key": "Key",
            "Compass": "Compass",
            "HeartContainerNoAnimation": "Heart Container (no animation)",
            "Bomb": "Single Bomb",
            "ThreeBombs": "Three Bombs",
            "Mushroom": "Mushroom",
            "RedBoomerang": "Magical Boomerang",
            "BottleWithRedPotion": "Bottle (Red Potion)",
            "BottleWithGreenPotion": "Bottle (Green Potion)",
            "BottleWithBluePotion": "Bottle (Blue Potion)",
            "RedPotion": "Red Potion",
            "GreenPotion": "Green Potion",
            "BluePotion": "Blue Potion",
            "TenBombs": "Ten Bombs",
            "BigKey": "Big Key",
            "Map": "Dungeon Map",
            "OneRupee": "One Rupee",
            "FiveRupees": "Five Rupees",
            "TwentyRupees": "Twenty Rupees",
            "PendantOfCourage": "Pendant Of Courage",
            "PendantOfWisdom": "Pendant Of Wisdom",
            "PendantOfPower": "Pendant Of Power",
            "BowAndArrows": "Bow And Arrows",
            "BowAndSilverArrows": "Bow And Silver Arrows",
            "BottleWithBee": "Bottle (Bee)",
            "BottleWithFairy": "Bottle (Fairy)",
            "BossHeartContainer": "Heart Container",
            "HeartContainer": "Sanctuary Heart Container",
            "OneHundredRupees": "One Hundred Rupees",
            "FiftyRupees": "Fifty Rupees",
            "Heart": "Small Heart",
            "Arrow": "Single Arrow",
            "ShopArrow": "Arrows",
            "TenArrows": "Ten Arrows",
            "SmallMagic": "Small Magic",
            "ThreeHundredRupees": "Three Hundred Rupees",
            "TwentyRupees2": "Twenty Rupees",
            "BottleWithGoldBee": "Bottle (Golden Bee)",
            "OcarinaActive": "Flute (active)",
            "PegasusBoots": "Pegasus Boots",
            "BombUpgrade5": "Bomb Upgrade (+5)",
            "BombUpgrade10": "Bomb Upgrade (+10)",
            "BombUpgrade50": "Bomb Upgrade (+50)",
            "ArrowUpgrade5": "Arrow Upgrade (+5)",
            "ArrowUpgrade10": "Arrow Upgrade (+10)",
            "ArrowUpgrade70": "Arrow Upgrade (+70)",
            "HalfMagic": "Half Magic",
            "QuarterMagic": "Quarter Magic",
            "Programmable1": "Programmable 1",
            "Programmable2": "Programmable 2",
            "Programmable3": "Programmable 3",
            "SilverArrowUpgrade": "Silver Arrows Upgrade",
            "Rupoor": "Rupoor",
            "RedClock": "Red Clock",
            "BlueClock": "Blue Clock",
            "GreenClock": "Green Clock",
            "ProgressiveSword": "Progressive Sword",
            "ProgressiveShield": "Progressive Shield",
            "ProgressiveArmor": "Progressive Armor",
            "ProgressiveGlove": "Progressive Glove",
            "L1Bombs": "Fighter Bombs",
            "L2Bombs": "Master Bombs",
            "L3Bombs": "Tempered Bombs",
            "L4Bombs": "Golden Bombs",
            "L5Bombs": "Super Golden Bombs",
            "ProgressiveBombs": "Progressive Bombs",
            "L1Cane": "Fighter Cane",
            "L2Cane": "Master Cane",
            "L3Cane": "Tempered Cane",
            "L4Cane": "Golden Cane",
            "L5Cane": "Super Golden Cane",
            "ProgressiveCane": "Progressive Cane",
            "ProgressiveNet": "Progressive Bug Net",
            "singleRNG": "Unique RNG Item",
            "multiRNG": "Non-Unique RNG Item",
            "ProgressiveBow": "Progressive Bow",
            "Triforce": "Triforce",
            "PowerStar": "Power Star",
            "TriforcePiece": "Triforce Piece",
            "MapLW": "Light World Map",
            "MapDW": "Dark World Map",
            "MapA2": "Ganons Tower Map",
            "MapD7": "Turtle Rock Map",
            "MapD4": "Thieves Town Map",
            "MapP3": "Tower of Hera Map",
            "MapD5": "Ice Palace Map",
            "MapD3": "Skull Woods Map",
            "MapD6": "Misery Mire Map",
            "MapD1": "Palace of Darkness Map",
            "MapD2": "Swamp Palace Map",
            "MapA1": "Agahnims Tower Map",
            "MapP2": "Desert Palace Map",
            "MapP1": "Eastern Palace Map",
            "MapH1": "Hyrule Castle Map",
            "MapH2": "Sewers Map",
            "CompassA2": "Ganons Tower Compass",
            "CompassD7": "Turtle Rock Compass",
            "CompassD4": "Thieves Town Compass",
            "CompassP3": "Tower of Hera Compass",
            "CompassD5": "Ice Palace Compass",
            "CompassD3": "Skull Woods Compass",
            "CompassD6": "Misery Mire Compass",
            "CompassD1": "Palace of Darkness Compass",
            "CompassD2": "Swamp Palace Compass",
            "CompassA1": "Agahnims Tower Compass",
            "CompassP2": "Desert Palace Compass",
            "CompassP1": "Eastern Palace Compass",
            "CompassH1": "Hyrule Castle Compass",
            "CompassH2": "Sewers Compass",
            "BigKeyA2": "Ganons Tower Big Key",
            "BigKeyD7": "Turtle Rock Big Key",
            "BigKeyD4": "Thieves Town Big Key",
            "BigKeyP3": "Tower of Hera Big Key",
            "BigKeyD5": "Ice Palace Big Key",
            "BigKeyD3": "Skull Woods Big Key",
            "BigKeyD6": "Misery Mire Big Key",
            "BigKeyD1": "Palace of Darkness Big Key",
            "BigKeyD2": "Swamp Palace Big Key",
            "BigKeyA1": "Agahnims Tower Big Key",
            "BigKeyP2": "Desert Palace Big Key",
            "BigKeyP1": "Eastern Palace Big Key",
            "BigKeyH1": "Hyrule Castle Big Key",
            "BigKeyH2": "Sewers Big Key",
            "KeyH2": "Sewers Key",
            "KeyH1": "Hyrule Castle Key",
            "KeyP1": "Eastern Palace Key",
            "KeyP2": "Desert Palace Key",
            "KeyA1": "Agahnims Tower Key",
            "KeyD2": "Swamp Palace Key",
            "KeyD1": "Palace of Darkness Key",
            "KeyD6": "Misery Mire Key",
            "KeyD3": "Skull Woods Key",
            "KeyD5": "Ice Palace Key",
            "KeyP3": "Tower of Hera Key",
            "KeyD4": "Thieves Town Key",
            "KeyD7": "Turtle Rock Key",
            "KeyA2": "Ganons Tower Key",
            "KeyGK": "Generic Key",
            "ShopKey": "Key",
            "Crystal1": "Crystal 1",
            "Crystal2": "Crystal 2",
            "Crystal3": "Crystal 3",
            "Crystal4": "Crystal 4",
            "Crystal5": "Crystal 5",
            "Crystal6": "Crystal 6",
            "Crystal7": "Crystal 7",
            "RescueZelda": "Rescue Zelda",
            "DefeatAgahnim": "Defeat Agahnim",
            "BigRedBomb": "Big Red Bomb",
            "DefeatAgahnim2": "Defeat Agahnim 2",
            "DefeatGanon": "Defeat Ganon",
            "ChocoboEgg": "Chocobo Egg",
            "NoSlipBoots": "Ice Cleats",
            "WinterCoat": "Winter Coat",
            "Duck": "Duck",
            "Reindeer1": "Dasher",
            "Reindeer2": "Dancer",
            "Reindeer3": "Prancer",
            "Reindeer4": "Vixen",
            "Reindeer5": "Comet",
            "Reindeer6": "Cupid",
            "Reindeer7": "Donner",
            "Reindeer8": "Blitzen",
            "Gift1": "Gift 1",
            "Gift2": "Gift 2",
            "Gift3": "Gift 3",
            "Gift4": "Gift 4",
            "Gift5": "Gift 5",
            "Gift6": "Gift 6",
            "Gift7": "Gift 7",
            "Coal1": "Coal",
            "Coal2": "Coal",
            "GoldenTicket": "Golden Ticket",
            "Armos Knights": "Armos Knights",
            "Lanmolas": "Lanmolas",
            "Moldorm": "Moldorm",
            "Helmasaur King": "Helmasaur King",
            "Arrghus": "Arrghus",
            "Mothula": "Mothula",
            "Blind": "Blind",
            "Kholdstare": "Kholdstare",
            "Vitreous": "Vitreous",
            "Trinexx": "Trinexx",
            "Agahnim": "Agahnim",
            "Agahnim 2": "Agahnim 2",
            "Ganon": "Ganon",
            "Test": "Testing Item"
        },
        "region": {
            "all": "All Regions",
            "Light World": "Light World",
            "Hyrule Castle": "Hyrule Castle",
            "Eastern Palace": "Eastern Palace",
            "Desert Palace": "Desert Palace",
            "Death Mountain": "Death Mountain",
            "Tower Of Hera": "Tower Of Hera",
            "Castle Tower": "Castle Tower",
            "Dark World": "Dark World",
            "Dark Palace": "Dark Palace",
            "Swamp Palace": "Swamp Palace",
            "Skull Woods": "Skull Woods",
            "Thieves Town": "Thieves Town",
            "Ice Palace": "Ice Palace",
            "Misery Mire": "Misery Mire",
            "Turtle Rock": "Turtle Rock",
            "Ganons Tower": "Ganons Tower",
            "Special": "Special"
        },
        "mystery": {
            "title": "Mystery",
            "generate": {
                "yaml_select": "Load Mystery YAML",
                "race": "Generate Race ROM",
                "race_warning": "Spoilers will <span class=\"running-now\">never</span> be available for this option.",
                "spoiler_race": "Generate Normal ROM",
                "casual": "Generate ROM",
                "back": "Change Settings",
                "forward": "View Generated Game",
                "regenerate": "Generate Again",
                "regenerate_tooltip": "Generate new game with same settings",
                "generating": "Generating...",
                "slow_warning": "Generation of seeds with complicated settings may take several minutes. Please be patient."
            },
            "details": {
                "title": "Game Details",
                "save_spoiler": "Save Spoiler",
                "save_rom": "Save ROM"
            }
        },
        "entrance": {
            "title": "Entrance Randomizer",
            "switch": {
                "item": "Switch to Item Randomizer"
            },
            "rom": {
                "options": "ROM Options"
            },
            "difficulty": {
                "title": "Difficulty",
                "options": {
                    "easy": "Easy",
                    "normal": "Normal",
                    "hard": "Hard",
                    "expert": "Expert",
                    "insane": "Insane"
                }
            },
            "goal": {
                "title": "Goal",
                "options": {
                    "ganon": "Defeat Ganon",
                    "crystals": "Crystals",
                    "dungeons": "All Dungeons",
                    "pedestal": "Master Sword Pedestal",
                    "triforcehunt": "Triforce Pieces"
                }
            },
            "logic": {
                "title": "Logic",
                "options": {
                    "NoGlitches": "No Glitches"
                }
            },
            "mode": {
                "title": "State",
                "options": {
                    "swordless": "Swordless",
                    "open": "Open"
                }
            },
            "shuffle": {
                "title": "Shuffle",
                "options": {
                    "simple": "Simple",
                    "restricted": "Restricted",
                    "full": "Full",
                    "crossed": "Crossed",
                    "insanity": "Insanity"
                }
            },
            "variation": {
                "title": "Variation",
                "options": {
                    "none": "None",
                    "timed-race": "Timed Race",
                    "timed-ohko": "Timed OHKO",
                    "ohko": "OHKO",
                    "triforce-hunt": "Triforce Piece Hunt",
                    "key-sanity": "Keysanity",
                    "retro": "Retro"
                }
            },
            "generate": {
                "race": "Generate Race ROM",
                "spoiler_race": "Spoiler Race ROM",
                "casual": "Generate ROM"
            },
            "details": {
                "title": "Game Details",
                "save_spoiler": "Save Spoiler",
                "save_rom": "Save ROM"
            }
        }
    },
    "es": {
        "enemizer": {
            "title": "Randomizer de enemigos (Enemizer)",
            "enable": "Activar Enemizer",
            "disable": "Desactivar Enemizer",
            "enemy_health": {
                "title": "Vida de enemigos",
                "options": [
                    "Normal",
                    "Fácil (1-4 hp)",
                    "Medio (2-15 hp)",
                    "Difícil (2-30 hp)",
                    "Locura (4-50 hp)"
                ]
            },
            "enemy_damage": {
                "title": "Daño de enemigos",
                "options": {
                    "off": "Normal",
                    "shuffle": "Aleatorio",
                    "chaos": "Caos"
                }
            },
            "bosses": {
                "title": "Jefes",
                "options": {
                    "off": "Normal",
                    "basic": "Básico",
                    "normal": "Normal",
                    "chaos": "Caos"
                }
            },
            "palette_shuffle": "Paleta aleatoria",
            "pot_shuffle": "Vasijas aleatorias",
            "enemy_shuffle": "Enemigos aleatorios"
        },
        "randomizer": {
            "title": "Randomizer",
            "preset": {
                "title": "Seleccionar plantilla",
                "customize": "Customizar",
                "options": {
                    "default": "Por Defecto",
                    "beginner": "Principiante",
                    "veetorp": "Glitches de Superfície (el favorito de Veetorp)",
                    "crosskeys": "Crosskeys",
                    "quick": "Súper Rápido",
                    "nightmare": "Pesadilla",
                    "tournament": "Torneo",
                    "custom": "Personalizado"
                }
            },
            "placement": {
                "title": "Colocación de Objetos"
            },
            "item_placement": {
                "title": "Colocación de Objetos",
                "options": {
                    "basic": "Básica",
                    "advanced": "Avanzada"
                }
            },
            "dungeon_items": {
                "title": "Objetos de Mazmorras",
                "options": {
                    "standard": "Normal",
                    "mc": "Mapas/Brújulas",
                    "mcs": "Mapas/Brújulas/Llaves pequeñas",
                    "full": "Keysanity"
                }
            },
            "accessibility": {
                "title": "Accesibilidad",
                "options": {
                    "items": "100% inventario",
                    "locations": "100% localizaciones",
                    "none": "Completable"
                }
            },
            "glitches_required": {
                "title": "Glitches Requeridos",
                "options": {
                    "none": "Ninguno",
                    "overworld_glitches": "Glitches de la Superfície",
                    "hybrid_major_glitches": "Glitches Mayores Híbridos",
                    "major_glitches": "Glitches Mayores",
                    "no_logic": "Sin lógica"
                },
                "glitch_warning": "Esta Lógica require conocimiento de Glithes Mayores<sup>**</sup>"
            },
            "goal": {
                "title": "Objetivo",
                "options": {
                    "ganon": "Derrotar a Ganon",
                    "fast_ganon": "Ganon Rápido",
                    "dungeons": "Todas las mazmorras",
                    "pedestal": "Pedestal de la Espada Maestra",
                    "triforce-hunt": "Piezas de la Trifuerza",
                    "ganonhunt": "Caza de Ganon"
                }
            },
            "tower_open": {
                "title": "Torre Abierta",
                "options": {
                    "0": "0 Cristales",
                    "1": "1 Cristal",
                    "2": "2 Cristales",
                    "3": "3 Cristales",
                    "4": "4 Cristales",
                    "5": "5 Cristales",
                    "6": "6 Cristales",
                    "7": "7 Cristales",
                    "random": "Aleatorio"
                }
            },
            "ganon_open": {
                "title": "Ganon Vulnerable",
                "options": {
                    "0": "0 Cristales",
                    "1": "1 Cristal",
                    "2": "2 Cristales",
                    "3": "3 Cristales",
                    "4": "4 Cristales",
                    "5": "5 Cristales",
                    "6": "6 Cristales",
                    "7": "7 Cristales",
                    "random": "Aleatorio"
                }
            },
            "gameplay": {
                "title": "Gameplay"
            },
            "world_state": {
                "title": "Estado del mundo",
                "options": {
                    "standard": "Estándar",
                    "open": "Abierto",
                    "inverted": "Inverso",
                    "retro": "Retro"
                }
            },
            "entrance_shuffle": {
                "title": "Randomizer de entradas",
                "options": {
                    "none": "Ninguno",
                    "simple": "Simple",
                    "restricted": "Restringido",
                    "full": "Completo",
                    "crossed": "Cruzado",
                    "insanity": "Locura"
                }
            },
            "boss_shuffle": {
                "title": "Randomizer de Jefes",
                "options": {
                    "none": "Ninguno",
                    "simple": "Simple",
                    "full": "Completo",
                    "random": "Aleatorio"
                }
            },
            "enemy_shuffle": {
                "title": "Randomizer de Enemigos",
                "options": {
                    "none": "Ninguno",
                    "shuffled": "Barajado",
                    "random": "Aleatorio"
                }
            },
            "hints": {
                "title": "Pistas",
                "options": {
                    "on": "On",
                    "off": "Off"
                }
            },
            "weapons": {
                "title": "Espadas",
                "options": {
                    "randomized": "Randomizadas",
                    "assured": "Aseguradas",
                    "vanilla": "Vanilla",
                    "swordless": "Sin Espadas"
                }
            },
            "item_pool": {
                "title": "Reserva de Objetos",
                "options": {
                    "easy": "Fácil",
                    "normal": "Normal",
                    "hard": "Difícil",
                    "expert": "Experto",
                    "crowd_control": "Crowd Control"
                },
                "crowd_control_warning": "<sup>*</sup> Esta opción está hecha para jugarse con la extensión de Twitch de <i>Crowd Control</i>. Para saber más: <a href=\"https://crowdcontrol.live/\" target=\"_blank\" rel=”noopener noreferrer”>https://crowdcontrol.live/</a>"
            },
            "item_functionality": {
                "title": "Funcionalidad de Objetos",
                "options": {
                    "easy": "Fácil",
                    "normal": "Normal",
                    "hard": "Difícil",
                    "expert": "Experto"
                }
            },
            "enemy_damage": {
                "title": "Daño de Enemigos",
                "options": {
                    "default": "Por Defecto",
                    "shuffled": "Barajado",
                    "random": "Aleatorio"
                }
            },
            "enemy_health": {
                "title": "Vida de Enemigos",
                "options": {
                    "default": "Por Defecto",
                    "easy": "Fácil",
                    "hard": "Difícil",
                    "expert": "Experto"
                }
            },
            "spoiler": {
                "title": "Spoilers",
                "options": {
                    "off": "Disabled",
                    "on": "Enabled",
                    "generate": "Solo en Generar"
                }
            },
            "generate": {
                "race": "Generar ROM para carreras",
                "race_warning": "<span class=\"running-now\">sin spoilers</span>",
                "spoiler_race": "Generar ROM para carreras (con spoilers)",
                "casual": "Generar ROM",
                "back": "Cambiar ajustes",
                "forward": "Ver juego generado",
                "regenerate": "Generar otra vez",
                "regenerate_tooltip": "Generar otra partida con las mismas opciones",
                "generating": "Generando..."
            },
            "details": {
                "title": "Detalles del juego",
                "save_spoiler": "Guardar spoiler",
                "save_rom": "Guardar ROM"
            },
            "variation": {
                "title": "Variación"
            },
            "difficulty": {
                "title": "Dificultad",
                "options": {
                    "easy": "Fácil",
                    "normal": "Normal",
                    "hard": "Difícil",
                    "expert": "Experto",
                    "insane": "Locura",
                    "crowdControl": "Crowd Control"
                }
            }
        },
        "error": {
            "title": "Error",
            "429": "Aunque apreciamos que quieras generar un montón de partidas, otras personas quieren hacerlo también. Por favor, vuelve más tarde si quieres generar más.",
            "failed_generation": "Error creando la semilla :(",
            "bad_file": "Archivo no reconocido",
            "quota_exceeded_error": "Has sobrepasado tu cuota de almacenamiento local."
        },
        "rom": {
            "loader": {
                "title": "Empezar a Jugar",
                "file_select": "Selecciona archivo ROM",
                "content": "<ol><li>Selecciona tu archivo ROM y cárgalo en tu navegador (Por favor, usa una ROM <strong>Zelda no Densetsu: Kamigami no Triforce v1.0</strong> con extensión .smc o .sfc)</li><li>Selecciona las <a href=\"/en/options\">Opciones de Juego</a> para cómo quieres que tu juego sea randomizado</li><li>Haz click en Generar ROM para carreras</li><li>Guarda tu ROM y ponte a jugar</li></ol>"
            },
            "info": {
                "spoilerwarning": "ADVERTENCIA: El generador de este juego ha visto el registro de spoiler.",
                "mystery": "Este es un juego de misterios. Debes descubrir las configuraciones mientras lo juegas!",
                "logic": "Glitches Requeridos",
                "accessibility": "Accesibilidad",
                "build": "Build de la ROM",
                "difficulty": "Dificultad",
                "variation": "Variación",
                "shuffle": "Randomizer de entradas",
                "mode": "Estado del mundo",
                "weapons": "Espadas",
                "goal": "Objetivo",
                "permalink": "Enlace permanente",
                "special": "Especial",
                "notes": "Notas",
                "generated": "Creada"
            },
            "settings": {
                "heart_speed": "Velocidad de Corazones",
                "heart_speeds": {
                    "off": "Desactivado",
                    "double": "Velocidad Doble",
                    "normal": "Velocidad Normal",
                    "half": "Media Velocidad",
                    "quarter": "Cuarto de Velocidad"
                },
                "menu_speed": "Velocidad de Menú",
                "menu_speeds": {
                    "instant": "Instantáneo",
                    "fast": "Rápido",
                    "normal": "Normal",
                    "slow": "Lento"
                },
                "heart_color": "Color de Corazones",
                "heart_colors": {
                    "blue": "Azul",
                    "green": "Verde",
                    "red": "Rojo",
                    "yellow": "Amarillo",
                    "random": "Aleatorio"
                },
                "play_as": "Jugar Como",
                "sprite_file_select": "Selecciona archivo .zspr",
                "msu1resume": "MSU-1 Continuar",
                "shuffle_sfx": "Mezcla SFX",
                "music": "Música de fondo",
                "music_info": "(poner en \"No\" para <a href=\"https://alttprlinks.page.link/SjiP\" target=\"_blank\" rel=\"noopener noreferrer\">soporte con MSU-1</a>)",
                "quickswap": "Cambio Rápido de Objetos",
                "palette_shuffle": "Paletas aleatorias",
                "race_warning": "No funciona en ROMs para carreras",
                "reduce_flashing": "Reducir Parpadeos intermitentes",
                "reduce_flashing_warning": "Esta opcion solo reduce el efecto del parpadeo, tu sensibilidad a estos efectos aun puede variar."
            }
        },
        "customizer": {
            "settings": {
                "timers": {
                    "off": "Sin temporizador",
                    "stopwatch": "Cronómetro",
                    "countdown-ohko": "Cuenta atrás (muerte súbita)",
                    "countdown-continue": "Cuenta atrás (continua)",
                    "countdown-stop": "Cuenta atrás (para)"
                },
                "dungeon_count": {
                    "off": "Desactivado",
                    "on": "Siempre visible",
                    "pickup": "Visible con brújula"
                }
            },
            "glitches": {
                "canBombJump": {
                    "title": "Salto Bomba",
                    "description": "Podría ser necesario tener que hacer Saltos Bomba para atravesar agujeros."
                },
                "canBootsClip": {
                    "title": "Clips de Botas",
                    "description": "Cuando se tengan las botas, podría ser necesario hacer <i>clips</i> a través de paredes de la superfície."
                },
                "canBunnyRevive": {
                    "title": "Reanimación como Conejo",
                    "description": "Podría ser necesario ir a algún sitio como conejo y abusar de morir o revivir con hadas para ser Link."
                },
                "canBunnySurf": {
                    "title": "Surf como Conejo",
                    "description": "Podría ser necesario andar sobre el agua en estado de conejo."
                },
                "canDungeonRevive": {
                    "title": "Reanimación en Mazmorras",
                    "description": "Podría ser necesario revivir como conejo en una mazmorra para conseguir objetos como Link."
                },
                "canFakeFlipper": {
                    "title": "Aletas Falsas",
                    "description": "Podría ser necesario usar el glitch de las Aletas Falsas para conseguir objetos."
                },
                "canMirrorClip": {
                    "title": "Clips de Espejo",
                    "description": "Podría ser necesario abusar la animación del espejo para salir del mapa."
                },
                "canMirrorWrap": {
                    "title": "Mirror Wrap",
                    "description": "Podría ser necesario usar el Espejo para hacer <i>scroll</i> automático a otro sitio."
                },
                "canOneFrameClipOW": {
                    "title": "Clip de un frame (superfície)",
                    "description": "Créeme, no quieres hacer esto."
                },
                "canOneFrameClipUW": {
                    "title": "One Frame Clip (underworld)",
                    "description": "Use 1 Frame Movement to clip between rooms of the underworld."
                },
                "canOWYBA": {
                    "title": "YBA (superfície)",
                    "description": "Podría ser necesario usar botellas en la superfície para teletransportarse a otras localizaciones."
                },
                "canSuperBunny": {
                    "title": "Súper Conejo",
                    "description": "Podría ser necesario activar el estado de súper conejo para acceder algunas localizaciones."
                },
                "canSuperSpeed": {
                    "title": "Súper Velocidad",
                    "description": "Podría ser necesario hacer <i>clips</i> con súper velocidad a través de esquinas de la superfície."
                },
                "canWaterFairyRevive": {
                    "title": "Reanimación en el Agua con Hadas",
                    "description": "Este <i>setup</i> es estúpido y requiere un montón de objetos."
                },
                "canWaterWalk": {
                    "title": "Andar por el Agua",
                    "description": "Podría ser necesario utilizar las Botas para andar sobre el agua."
                },
                "noLogic": {
                    "title": "Desactivar todas las comprobaciones de lógica",
                    "description": "Cuando esto está activado, todas las garantías desaparecen, y nada de lo que hay aquí importa."
                }
            }
        },
        "item": {
            "Random": "Aleatorio",
            "BottleWithRandom": "Botella (aleatoria)",
            "Nothing": "Nada",
            "UncleSword": "Espada Progresiva",
            "L1Sword": "Espada Normal",
            "L1SwordAndShield": "Espada y Escudo",
            "L2Sword": "Espada Maestra",
            "MasterSword": "Espada Maestra",
            "L3Sword": "Espada Templada",
            "L4Sword": "Espada Dorada",
            "BlueShield": "Escudo Pequeño",
            "RedShield": "Escudo Rojo",
            "MirrorShield": "Escudo Espejo",
            "FireRod": "Cetro de Fuego",
            "IceRod": "Cetro de Hielo",
            "Hammer": "Martillo",
            "Hookshot": "Gancho",
            "Bow": "Arco",
            "Boomerang": "Bumerán Azul",
            "Powder": "Polvos Mágicos",
            "Bee": "Abeja",
            "Bombos": "Bombos",
            "Ether": "Ether",
            "Quake": "Quake",
            "Lamp": "Lámpara",
            "Shovel": "Pala",
            "OcarinaInactive": "Flauta",
            "CaneOfSomaria": "Vara de Somaria",
            "Bottle": "Botella (vacía)",
            "PieceOfHeart": "Pieza de Corazón",
            "CaneOfByrna": "Vara de Byrna",
            "Cape": "Capa Mágica",
            "MagicMirror": "Espejo Mágico",
            "PowerGlove": "Guante de Poder",
            "TitansMitt": "Guante Titán",
            "BookOfMudora": "Libro de Mudora",
            "Flippers": "Aletas",
            "MoonPearl": "Perla Lunar",
            "BugCatchingNet": "Cazamariposas",
            "BlueMail": "Malla Azul",
            "RedMail": "Malla Roja",
            "Key": "Llave",
            "Compass": "Brújula",
            "HeartContainerNoAnimation": "Contenedor de Corazón (sin animación)",
            "Bomb": "Bomba",
            "ThreeBombs": "Tres Bombas",
            "Mushroom": "Seta",
            "RedBoomerang": "Bumerán Mágico",
            "BottleWithRedPotion": "Botella (Poción Roja)",
            "BottleWithGreenPotion": "Botella (Poción Verde)",
            "BottleWithBluePotion": "Botella (Poción Azul)",
            "RedPotion": "Poción Roja",
            "GreenPotion": "Poción Verde",
            "BluePotion": "Poción Azul",
            "TenBombs": "Diez Bombas",
            "BigKey": "Llave Grande",
            "Map": "Mapa de la Mazmorra",
            "OneRupee": "Una Rupia",
            "FiveRupees": "Cinco Rupias",
            "TwentyRupees": "Veinte Rupias",
            "PendantOfCourage": "Colgante del Valor",
            "PendantOfWisdom": "Colgante de la Sabiduría",
            "PendantOfPower": "Colgante del Poder",
            "BowAndArrows": "Arco y Flechas",
            "BowAndSilverArrows": "Arco y Flechas de Plata",
            "BottleWithBee": "Botella (Abeja)",
            "BottleWithFairy": "Botella (Hada)",
            "BossHeartContainer": "Contenedor de Corazón",
            "HeartContainer": "Contenedor de Corazón del Santuario",
            "OneHundredRupees": "Cien Rupias",
            "FiftyRupees": "Cincuenta Rupias",
            "Heart": "Corazón Pequeño",
            "Arrow": "Una Flecha",
            "ShopArrow": "Arrows",
            "TenArrows": "Dies Flechas",
            "SmallMagic": "Magia Pequeña",
            "ThreeHundredRupees": "Trescientas Rupias",
            "TwentyRupees2": "Veinte Rupias",
            "BottleWithGoldBee": "Botella (Abeja Dorada)",
            "OcarinaActive": "Flauta (activada)",
            "PegasusBoots": "Botas de Pegaso",
            "BombUpgrade5": "Mejora de Bombas (+5)",
            "BombUpgrade10": "Mejora de Bombas (+10)",
            "BombUpgrade50": "Mejora de Bombas (+50)",
            "ArrowUpgrade5": "Mejora de Flechas (+5)",
            "ArrowUpgrade10": "Mejora de Flechas (+10)",
            "ArrowUpgrade70": "Mejora de Flechas (+70)",
            "HalfMagic": "Media Magia",
            "QuarterMagic": "Cuarto de Magia",
            "Programmable1": "Programable 1",
            "Programmable2": "Programable 2",
            "Programmable3": "Programable 3",
            "SilverArrowUpgrade": "Mejora de Flechas de Plata",
            "Rupoor": "Rupobre",
            "RedClock": "Reloj Rojo",
            "BlueClock": "Reloj Azul",
            "GreenClock": "Reloj Verde",
            "ProgressiveSword": "Espada Progresiva",
            "ProgressiveShield": "Escudo Progresivo",
            "ProgressiveArmor": "Armadura Progresiva",
            "ProgressiveGlove": "Guante Progresivo",
            "singleRNG": "Objeto aleatorio Único",
            "multiRNG": "Objeto aleatorio No Único",
            "ProgressiveBow": "Arco Progresivo",
            "Triforce": "Trifuerza",
            "PowerStar": "Estrella de Poder",
            "TriforcePiece": "Pieza de la Trifuerza",
            "MapLW": "Mapa del Mundo de la Luz",
            "MapDW": "Mapa del Mundo Oscuro",
            "MapA2": "Mapa de la Torre de Ganon",
            "MapD7": "Mapa de Roca Tortuga",
            "MapD4": "Mapa de Cueva de los Bandidos",
            "MapP3": "Mapa de la Torre de Hera",
            "MapD5": "Mapa del Palacio de Hielo",
            "MapD3": "Mapa de Bosque de Osamentas",
            "MapD6": "Mapa de Gruta de las Marismas",
            "MapD1": "Mapa del Palacio Oscuro",
            "MapD2": "Mapa de las Ruinas del Pantano",
            "MapA1": "Mapa de la Torre de Agahnim",
            "MapP2": "Mapa del Palacio del Desierto",
            "MapP1": "Mapa del Palacio del Este",
            "MapH1": "Mapa del Castillo de Hyrule",
            "MapH2": "Mapa de las Cloacas",
            "CompassA2": "Brújula de la Torre de Ganon",
            "CompassD7": "Brújula de Roca Tortuga",
            "CompassD4": "Brújula de Cueva de los Bandidos",
            "CompassP3": "Brújula de la Torre de Hera",
            "CompassD5": "Brújula del Palacio de Hielo",
            "CompassD3": "Brújula de Bosque de Osamentas",
            "CompassD6": "Brújula de Gruta de las Marismas",
            "CompassD1": "Brújula del Palacio Oscuro",
            "CompassD2": "Brújula de las Ruinas del Pantano",
            "CompassA1": "Brújula de la Torre de Agahnim",
            "CompassP2": "Brújula del Palacio del Desierto",
            "CompassP1": "Brújula del Palacio del Este",
            "CompassH1": "Brújula del Castillo de Hyrule",
            "CompassH2": "Brújula de las Cloacas",
            "BigKeyA2": "Llave Grande de la Torre de Ganon",
            "BigKeyD7": "Llave Grande de Roca Tortuga",
            "BigKeyD4": "Llave Grande de Cueva de los Bandidos",
            "BigKeyP3": "Llave Grande de la Torre de Hera",
            "BigKeyD5": "Llave Grande del Palacio de Hielo",
            "BigKeyD3": "Llave Grande de Bosque de Osamentas",
            "BigKeyD6": "Llave Grande de Gruta de las Marismas",
            "BigKeyD1": "Llave Grande del Palacio Oscuro",
            "BigKeyD2": "Llave Grande de las Ruinas del Pantano",
            "BigKeyA1": "Llave Grande de la Torre de Agahnim",
            "BigKeyP2": "Llave Grande del Palacio del Desierto",
            "BigKeyP1": "Llave Grande del Palacio del Este",
            "BigKeyH1": "Llave Grande del Castillo de Hyrule",
            "BigKeyH2": "Llave Grande de las Cloacas",
            "KeyH2": "Llave de las Cloacas",
            "KeyH1": "Llave del Castillo de Hyrule",
            "KeyP1": "Llave del Palacio del Este",
            "KeyP2": "Llave del Palacio del Desierto",
            "KeyA1": "Llave de la Torre de Agahnim",
            "KeyD2": "Llave de las Ruinas del Pantano",
            "KeyD1": "Llave del Palacio Oscuro",
            "KeyD6": "Llave de Gruta de las Marismas",
            "KeyD3": "Llave de Bosque de Osamentas",
            "KeyD5": "Llave del Palacio de Hielo",
            "KeyP3": "Llave de la Torre de Hera",
            "KeyD4": "Llave de Cueva de los Bandidos",
            "KeyD7": "Llave de Roca Tortuga",
            "KeyA2": "Llave de la Torre de Ganon",
            "KeyGK": "Llave Genérica",
            "ShopKey": "Key",
            "Crystal1": "Cristal 1",
            "Crystal2": "Cristal 2",
            "Crystal3": "Cristal 3",
            "Crystal4": "Cristal 4",
            "Crystal5": "Cristal 5",
            "Crystal6": "Cristal 6",
            "Crystal7": "Cristal 7",
            "RescueZelda": "Rescata a Zelda",
            "DefeatAgahnim": "Derrota a Agahnim",
            "BigRedBomb": "Bomba Grande",
            "DefeatAgahnim2": "Derrota a Agahnim 2",
            "DefeatGanon": "Derrota a Ganon",
            "ChocoboEgg": "Huevo de Chocobo",
            "NoSlipBoots": "Botas antideslizantes",
            "WinterCoat": "Abrigo de Invierno",
            "Duck": "Pato",
            "Reindeer1": "Vondín",
            "Reindeer2": "Danzarín",
            "Reindeer3": "Chiqui",
            "Reindeer4": "Juguetón",
            "Reindeer5": "Cometa",
            "Reindeer6": "Cupido",
            "Reindeer7": "Trueno",
            "Reindeer8": "Relámpago",
            "Gift1": "Regalo 1",
            "Gift2": "Regalo 2",
            "Gift3": "Regalo 3",
            "Gift4": "Regalo 4",
            "Gift5": "Regalo 5",
            "Gift6": "Regalo 6",
            "Gift7": "Regalo 7",
            "Coal1": "Carbón",
            "Coal2": "Carbón",
            "GoldenTicket": "Golden Ticket",
            "Armos Knights": "Armos Max",
            "Lanmolas": "Lanmolas",
            "Moldorm": "Moldorm",
            "Helmasaur King": "Rey Yelmasaurio",
            "Arrghus": "Arghus",
            "Mothula": "Polillántula",
            "Blind": "Cegatox",
            "Kholdstare": "Heladonte",
            "Vitreous": "Vitreus",
            "Trinexx": "Trínex",
            "Agahnim": "Agahnim",
            "Agahnim 2": "Agahnim 2",
            "Ganon": "Ganon"
        },
        "entrance": {
            "title": "Randomizer de Entradas",
            "switch": {
                "item": "Cambiar a randomizer de objetos"
            },
            "rom": {
                "options": "Opciones de ROM"
            },
            "difficulty": {
                "title": "Dificultad",
                "options": {
                    "easy": "Fácil",
                    "normal": "Normal",
                    "hard": "Difícil",
                    "expert": "Experto",
                    "insane": "Locura"
                }
            },
            "goal": {
                "title": "Objetivo",
                "options": {
                    "ganon": "Derrotar a Ganon",
                    "crystals": "Cristales",
                    "dungeons": "Todas las mazmorras",
                    "pedestal": "Pedestal de la Espada Maestra",
                    "triforcehunt": "Piezas de la Trifuerza"
                }
            },
            "logic": {
                "title": "Lógica",
                "options": {
                    "NoGlitches": "Sin Glitches"
                }
            },
            "mode": {
                "title": "Tipo",
                "options": {
                    "swordless": "Sin espadas",
                    "open": "Abierto"
                }
            },
            "shuffle": {
                "title": "Orden",
                "options": {
                    "simple": "Simple",
                    "restricted": "Restringido",
                    "full": "Completo",
                    "crossed": "Cruzado",
                    "insanity": "Locura"
                }
            },
            "variation": {
                "title": "Variación",
                "options": {
                    "none": "Ninguna",
                    "timed-race": "Carrera cronometrada",
                    "timed-ohko": "Muerte Súbita cronometrada",
                    "ohko": "Muerte Súbita",
                    "triforce-hunt": "Caza de la Trifuerza",
                    "key-sanity": "Keysanity",
                    "retro": "Retro"
                }
            },
            "generate": {
                "race": "Generar ROM para carreras",
                "spoiler_race": "Generar ROM para carreras",
                "casual": "Generar ROM"
            },
            "details": {
                "title": "Detalles del juego",
                "save_spoiler": "Guardar spoiler",
                "save_rom": "Guardar ROM"
            }
        }
    },
    "fr": {
        "enemizer": {
            "title": "Enemizer",
            "enable": "Activer l’Ennemiseur",
            "disable": "Désactiver l’Ennemiseur",
            "enemy_health": {
                "title": "Santé Ennemis",
                "options": [
                    "Ordinaire",
                    "Facile (1-4 hp)",
                    "Moyen (2-15 hp)",
                    "Difficile (2-30 hp)",
                    "Insensé (4-50 hp)"
                ]
            },
            "enemy_damage": {
                "title": "Dégâts des Ennemis",
                "options": {
                    "off": "Ordinaire",
                    "shuffle": "Mélangé",
                    "chaos": "Chaos"
                }
            },
            "bosses": {
                "title": "Bosses",
                "options": {
                    "off": "Ordinaire",
                    "basic": "De base",
                    "normal": "Commun",
                    "chaos": "Chaos"
                }
            },
            "palette_shuffle": "Mélange les Palettes",
            "pot_shuffle": "Mélange les Pots",
            "enemy_shuffle": "Mélanger les Ennemis"
        },
        "randomizer": {
            "title": "Randomiseur",
            "preset": {
                "title": "Choisissez vos Paramètres",
                "customize": "Customisation",
                "options": {
                    "default": "Par défaut",
                    "beginner": "Débutant",
                    "veetorp": "OWG (La préférée de Veetorp!)",
                    "crosskeys": "Clésordre et Entrées",
                    "quick": "Super Rapide",
                    "nightmare": "Cauchemars",
                    "tournament": "Tournoi",
                    "custom": "Personnalisé"
                }
            },
            "placement": {
                "title": "Placement des objets"
            },
            "item_placement": {
                "title": "Placement des objets",
                "options": {
                    "basic": "Basique",
                    "advanced": "Avancé"
                }
            },
            "dungeon_items": {
                "title": "Objets des Donjons",
                "options": {
                    "standard": "Standard",
                    "mc": "Cartes et Boussoles",
                    "mcs": "Cartes, Boussoles et Petites Clefs",
                    "full": "Clésordre"
                }
            },
            "accessibility": {
                "title": "Accessibilité",
                "options": {
                    "items": "100% Inventaire",
                    "locations": "100% Accessible",
                    "none": "Achevable"
                }
            },
            "glitches_required": {
                "title": "Glitchs requis",
                "options": {
                    "none": "Aucun",
                    "overworld_glitches": "Glitchs Monde Extérieur",
                    "hybrid_major_glitches": "Glitchs Majeurs Hybrides",
                    "major_glitches": "Glitchs Majeurs",
                    "no_logic": "Sans Logique"
                },
                "glitch_warning": "Cette logique nécessite la connaissance de glitchs majeurs<sup>**</sup>"
            },
            "goal": {
                "title": "Objectif",
                "options": {
                    "ganon": "Vaincre Ganon",
                    "fast_ganon": "Rapide Ganon",
                    "dungeons": "Tous les Donjons",
                    "pedestal": "Piédestal de la Master Sword",
                    "triforce-hunt": "Morceaux de Triforce ",
                    "ganonhunt": "Ganonhunt"
                }
            },
            "tower_open": {
                "title": "Ouvrir la Tour",
                "options": {
                    "0": "0 Cristaux",
                    "1": "1 Cristal",
                    "2": "2 Cristaux",
                    "3": "3 Cristaux",
                    "4": "4 Cristaux",
                    "5": "5 Cristaux",
                    "6": "6 Cristaux",
                    "7": "7 Cristaux",
                    "random": "Aléatoire"
                }
            },
            "ganon_open": {
                "title": "Vulnérabilité de Ganon",
                "options": {
                    "0": "0 Cristaux",
                    "1": "1 Cristal",
                    "2": "2 Cristaux",
                    "3": "3 Cristaux",
                    "4": "4 Cristaux",
                    "5": "5 Cristaux",
                    "6": "6 Cristaux",
                    "7": "7 Cristaux",
                    "random": "Aléatoire"
                }
            },
            "gameplay": {
                "title": "Gameplay"
            },
            "world_state": {
                "title": "État du Monde",
                "options": {
                    "standard": "Standard",
                    "open": "Ouvert",
                    "inverted": "Inversé",
                    "retro": "Rétro"
                }
            },
            "entrance_shuffle": {
                "title": "Mélangeur d’Entrées",
                "options": {
                    "none": "Désactivé",
                    "simple": "Simple",
                    "restricted": "Restreint",
                    "full": "Complet",
                    "crossed": "Croisé",
                    "insanity": "Insensé"
                }
            },
            "boss_shuffle": {
                "title": "Mélangeur de Boss",
                "options": {
                    "none": "Désactivé",
                    "simple": "Simple",
                    "full": "Complet",
                    "random": "Aléatoire"
                }
            },
            "enemy_shuffle": {
                "title": "Mélangeur d’Ennemis",
                "options": {
                    "none": "Désactivé",
                    "shuffled": "Intervertis",
                    "random": "Aléatoires"
                }
            },
            "hints": {
                "title": "Indices",
                "options": {
                    "on": "Activés",
                    "off": "Désactivés"
                }
            },
            "weapons": {
                "title": "Épées",
                "options": {
                    "randomized": "Randomisées",
                    "assured": "Assurée",
                    "vanilla": "Originales",
                    "swordless": "Sans Épée"
                }
            },
            "item_pool": {
                "title": "Objets disponibles",
                "options": {
                    "easy": "Facile",
                    "normal": "Normal",
                    "hard": "Difficile",
                    "expert": "Expert",
                    "crowd_control": "Crowd Control"
                },
                "crowd_control_warning": "<sup>*</sup> Ce paramètre est prévu pour être utilisé avec l’extension Twitch Crowd Control. En savoir plus: <a href=\"https://crowdcontrol.live/\" target=\"_blank\" rel=”noopener noreferrer”>https://crowdcontrol.live/</a>"
            },
            "item_functionality": {
                "title": "Fonctionnalité des Objets",
                "options": {
                    "easy": "Facile",
                    "normal": "Normal",
                    "hard": "Difficile",
                    "expert": "Expert"
                }
            },
            "enemy_damage": {
                "title": "Dégâts des Ennemis",
                "options": {
                    "default": "Par défaut",
                    "shuffled": "Intervertis",
                    "random": "Aléatoire"
                }
            },
            "enemy_health": {
                "title": "Vie des Ennemis",
                "options": {
                    "default": "Par défaut",
                    "easy": "Facile",
                    "hard": "Difficile",
                    "expert": "Expert"
                }
            },
            "spoiler": {
                "title": "Spoilers",
                "options": {
                    "off": "Desactivé",
                    "on": "Activé",
                    "generate": "Seulement sur Generate"
                }
            },
            "generate": {
                "race": "Générer une ROM de Course",
                "race_warning": "Les spoilers ne seront <span class=\"running-now\">jamais</span> disponibles pour cette option.",
                "spoiler_race": "Générer une ROM avec Spoiler",
                "casual": "Générer une ROM",
                "back": "Changer les Paramètres",
                "forward": "Voir le jeu généré",
                "regenerate": "Générer à nouveau",
                "regenerate_tooltip": "Générer à nouveau avec les mêmes paramètres",
                "generating": "Génération..."
            },
            "details": {
                "title": "Détails du jeu",
                "save_spoiler": "Enregistrer la spoiler",
                "save_rom": "Sauvegarder la ROM"
            },
            "variation": {
                "title": "Variation"
            },
            "difficulty": {
                "title": "Difficulté",
                "options": {
                    "easy": "Easy",
                    "normal": "Normal",
                    "hard": "Difficile",
                    "expert": "Expert",
                    "insane": "Insensé",
                    "crowdControl": "Crowd Control"
                }
            }
        },
        "error": {
            "title": "Erreur",
            "429": "Bien que nous appréciions que vous souhaitiez générer beaucoup de jeux, d’autres personnes aimeraient également le faire. Veuillez revenir plus tard si vous souhaitez continuer à générer.",
            "failed_generation": "Échec de la création de jeu :(",
            "bad_file": "Fichier non reconnu",
            "quota_exceeded_error": "Vous avez atteint la limite de stockage local."
        },
        "rom": {
            "loader": {
                "title": "Pour commencer",
                "file_select": "Sélectionnez le fichier ROM",
                "content": "<ol><li>Sélectionnez votre fichier ROM et chargez-le dans le navigateur (utilisez une ROM <strong>Zelda no Densetsu: Kamigami no Triforce v1.0</strong> avec une extension .smc ou .sfc)</li><li>Sélectionnez les <a href=\"/fr/options\">Options de Jeu</a> pour déterminer de quelle façon le jeu sera randomisé</li><li>Cliquez sur Générer une ROM de Course</li><li>Ensuite, sauvegardez votre ROM et commencez à jouer</li></ol>"
            },
            "info": {
                "spoilerwarning": "AVERTISSEMENT : La personne qui a généré cette partie a regardé le spoiler log.",
                "mystery": "Ceci est une partie mystère. Les paramètres seront à découvrir pendant que vous jouez!",
                "logic": "Glitchs requis",
                "accessibility": "Accessibilité",
                "build": "Création de ROM",
                "difficulty": "Difficulté",
                "variation": "Variation",
                "shuffle": "Mélangeur d’Entrées",
                "mode": "État du Monde",
                "weapons": "Épées",
                "goal": "Objectif",
                "permalink": "Lien permanent",
                "special": "Spécial",
                "notes": "Remarques",
                "generated": "Créé"
            },
            "settings": {
                "heart_speed": "Bip de vie faible",
                "heart_speeds": {
                    "off": "Éteint",
                    "double": "Vitesse Double",
                    "normal": "Vitesse Normale",
                    "half": "Moitié de Vitesse",
                    "quarter": "Quart de Vitesse"
                },
                "menu_speed": "Vitesse du menu",
                "menu_speeds": {
                    "instant": "Immédiat",
                    "fast": "Rapide",
                    "normal": "Normal",
                    "slow": "Lent"
                },
                "heart_color": "Couleur des coeurs",
                "heart_colors": {
                    "blue": "Bleu",
                    "green": "Vert",
                    "red": "Rouge",
                    "yellow": "Jaune",
                    "random": "Aléatoire"
                },
                "play_as": "Jouer en tant que",
                "sprite_file_select": "Sélectionnez le fichier .zspr",
                "msu1resume": "Reprise MSU-1",
                "shuffle_sfx": "SFX mélangé",
                "music": "Musique de fond",
                "music_info": "(définie sur \"Non\" pour <a href=\"https://alttprlinks.page.link/SjiP\" target=\"_blank\" rel=\"noopener noreferrer\">le support MSU-1</a>)",
                "quickswap": "Changement rapide",
                "palette_shuffle": "Couleurs mélangées",
                "race_warning": "Ne fonctionne pas dans les ROMs de course",
                "reduce_flashing": "Réduit le clignotement",
                "reduce_flashing_warning": "Cette option réduit l'effet de clignotement. Votre sensibilité aux effets de clignotement peut varier."
            }
        },
        "customizer": {
            "settings": {
                "timers": {
                    "off": "Désactivé",
                    "stopwatch": "Contre-la-montre",
                    "countdown-ohko": "Compte à rebours OHKO",
                    "countdown-continue": "Compte à rebours",
                    "countdown-stop": "Compte à rebours Fin du jeu"
                },
                "dungeon_count": {
                    "off": "Désactivé",
                    "on": "Toujours activé",
                    "pickup": "Avec Boussole"
                }
            },
            "glitches": {
                "canBombJump": {
                    "title": "Saut à la Bombe",
                    "description": "Il peut être requis de sauter par dessus un gouffre avec une bombe."
                },
                "canBootsClip": {
                    "title": "Clip aux Bottes",
                    "description": "Avec les bottes, il peut être requis de passer à travers de murs, dans le monde extérieur."
                },
                "canBunnyRevive": {
                    "title": "Résurrection du Lapin",
                    "description": "Il peut être requis de se rendre quelque part en forme de Lapin, et de mourir/user une fée pour redevenir Link."
                },
                "canBunnySurf": {
                    "title": "Lapin Surfeur",
                    "description": "Il peut être requis de marcher sur l’eau en tant que Lapin."
                },
                "canDungeonRevive": {
                    "title": "Résurrection en Donjon",
                    "description": "Il peut être requis d’entrer dans un donjon en Lapin, et de mourir, afin de redevenir Link pour collecter des objets."
                },
                "canFakeFlipper": {
                    "title": "Fausses Palmes",
                    "description": "Il peut être requis de faire la technique des Fausses Palmes afin de récupérer des objets."
                },
                "canMirrorClip": {
                    "title": "Clip au Miroir",
                    "description": "Il peut être requis d’utiliser des rebonds avec le Miroir pour se transporter hors des limites du jeu."
                },
                "canMirrorWrap": {
                    "title": "Wrap au Miroir",
                    "description": "Il peut être requis d\\utiliser le Miroir afin de défiler l’écran à un endroit normalement inaccessible."
                },
                "canOneFrameClipOW": {
                    "title": "Clip d\\Une Image (Monde extérieur)",
                    "description": "Vous ne voulez pas faire ça. Croyez-moi.."
                },
                "canOneFrameClipUW": {
                    "title": "One Frame Clip (underworld)",
                    "description": "Use 1 Frame Movement to clip between rooms of the underworld."
                },
                "canOWYBA": {
                    "title": "YBA (Monde extérieur)",
                    "description": "Il peut être requis d’utiliser des Bocaux dans le monde extérieur afin de se rendre à un endroit normalement inaccessible."
                },
                "canSuperBunny": {
                    "title": "Super Lapin",
                    "description": "Il peut être requis d’activer la technique du Super Lapin pour accéder à certains endroits et objets."
                },
                "canSuperSpeed": {
                    "title": "Super Vitesse",
                    "description": "Il peut être requis d’utiliser la Super Vitesse afin de passer à travers une barrière dans le monde extérieur."
                },
                "canWaterFairyRevive": {
                    "title": "Résurrection par une Fée dans l’Eau",
                    "description": "Cette technique est ridicule et requiert un grand nombre d’objets."
                },
                "canWaterWalk": {
                    "title": "Marche sur l’Eau",
                    "description": "Il peut être requis d’utiliser les Bottes pour marcher sur l\\eau."
                },
                "noLogic": {
                    "title": "Désactiver la Logique",
                    "description": "Quand ceci est activé, les dés en sont jetés, et rien d’autre n’importe.."
                }
            }
        },
        "item": {
            "Random": "Random",
            "BottleWithRandom": "Bottle (Random)",
            "Nothing": "Rien",
            "UncleSword": "Épée progressive",
            "L1Sword": "Épée de combat",
            "L1SwordAndShield": "Épée et Bouclier de combat",
            "L2Sword": "Master Sword",
            "MasterSword": "Master Sword",
            "L3Sword": "Épée trempée",
            "L4Sword": "Épée d’or",
            "BlueShield": "Bouclier de combat",
            "RedShield": "Bouclier de feu",
            "MirrorShield": "Bouclier miroir",
            "FireRod": "Baguette de Feu",
            "IceRod": "Baguette de Glace",
            "Hammer": "Marteau",
            "Hookshot": "Grappin",
            "Bow": "Arc",
            "Boomerang": "Boomerang Bleu",
            "Powder": "Poudre magique",
            "Bee": "Abeille",
            "Bombos": "Bombos",
            "Ether": "Ether",
            "Quake": "Quake",
            "Lamp": "Lampe",
            "Shovel": "Pelle",
            "OcarinaInactive": "Flûte",
            "CaneOfSomaria": "Canne De Somaria",
            "Bottle": "Flacon (vide)",
            "PieceOfHeart": "Quart de Coeur",
            "CaneOfByrna": "Canne De Byrna",
            "Cape": "Cape Magique",
            "MagicMirror": "Miroir Magique",
            "PowerGlove": "Gants de puissance",
            "TitansMitt": "Gants des Titans",
            "BookOfMudora": "Livre De Mudora",
            "Flippers": "Palmes",
            "MoonPearl": "Perle de lune",
            "BugCatchingNet": "Filet à papillon",
            "BlueMail": "Tunique bleue",
            "RedMail": "Tunique rouge",
            "Key": "Clé",
            "Compass": "Boussole",
            "HeartContainerNoAnimation": "Réceptacle de coeur (pas d’animation)",
            "Bomb": "Une Bombe",
            "ThreeBombs": "Trois Bombes",
            "Mushroom": "Champignon",
            "RedBoomerang": "Boomerang magique",
            "BottleWithRedPotion": "Flacon (potion rouge)",
            "BottleWithGreenPotion": "Flacon (potion verte)",
            "BottleWithBluePotion": "Flacon (potion bleue)",
            "RedPotion": "Potion Rouge",
            "GreenPotion": "Potion Verte",
            "BluePotion": "Potion Bleue",
            "TenBombs": "Dix Bombes",
            "BigKey": "Grande Clé",
            "Map": "Carte du Donjon",
            "OneRupee": "Un Rubis",
            "FiveRupees": "Cinq Rubiss",
            "TwentyRupees": "Vingt Rubis",
            "PendantOfCourage": "Pendentif du courage",
            "PendantOfWisdom": "Pendentif de sagesse",
            "PendantOfPower": "Pendentif de puissance",
            "BowAndArrows": "Arc et Flèches",
            "BowAndSilverArrows": "Arc Et Flèches d’Argent ",
            "BottleWithBee": "Flacon (abeille)",
            "BottleWithFairy": "Flacon (fée)",
            "BossHeartContainer": "Réceptacle de coeur",
            "HeartContainer": "Réceptacle de coeur du sanctuaire",
            "OneHundredRupees": "Cent Rubis",
            "FiftyRupees": "Cinquante Rubis",
            "Heart": "Petit coeur",
            "Arrow": "La Flèche",
            "ShopArrow": "Arrows",
            "TenArrows": "Dix Flèches",
            "SmallMagic": "Petite magie",
            "ThreeHundredRupees": "Trois cent Rubis",
            "TwentyRupees2": "Vingt Rubis",
            "BottleWithGoldBee": "Flacon (Abeille D’or)",
            "OcarinaActive": "Flûte (activée)",
            "PegasusBoots": "Bottes Pégase",
            "BombUpgrade5": "Extension de Sac de Bombes (+5)",
            "BombUpgrade10": "Extension de Sac de Bombes (+10)",
            "BombUpgrade50": "Extension de Sac de Bombes (+50)",
            "ArrowUpgrade5": "Extension de carquois (+5)",
            "ArrowUpgrade10": "Extension de carquois (+10)",
            "ArrowUpgrade70": "Extension de carquois (+70)",
            "HalfMagic": "Demi-magie",
            "QuarterMagic": "Quart de magie",
            "Programmable1": "Programmable 1",
            "Programmable2": "Programmable 2",
            "Programmable3": "Programmable 3",
            "SilverArrowUpgrade": "Flèches d’argent",
            "Rupoor": "Rupoor",
            "RedClock": "Horloge rouge",
            "BlueClock": "Horloge bleue",
            "GreenClock": "Horloge verte",
            "ProgressiveSword": "Épée progressive",
            "ProgressiveShield": "Bouclier Progressif",
            "ProgressiveArmor": "Armure progressive",
            "ProgressiveGlove": "Gant Progressif",
            "singleRNG": "Objet RNG unique",
            "multiRNG": "Objet RNG non unique",
            "ProgressiveBow": "Arc Progressif",
            "Triforce": "Triforce",
            "PowerStar": "Étoile de puissance",
            "TriforcePiece": "Pièce Triforce",
            "MapLW": "Carte du monde de la lumière",
            "MapDW": "Carte du monde des ténèbres",
            "MapA2": "Carte de Ganons Tower",
            "MapD7": "Carte de Turtle Rock",
            "MapD4": "Carte de Thieves Town",
            "MapP3": "Carte de Hera Tower",
            "MapD5": "Carte de Ice Palace",
            "MapD3": "Carte de Skulls Woods",
            "MapD6": "Carte de Misery Mire",
            "MapD1": "Carte de Palace of Darkness",
            "MapD2": "Carte de Swamp Palace",
            "MapA1": "Carte de Agahnim Tower",
            "MapP2": "Carte de Desert Palace",
            "MapP1": "Carte de Eastern Palace",
            "MapH1": "Carte de Hyrule Castle",
            "MapH2": "Carte de Sewers",
            "CompassA2": "Boussole de Ganons Tower",
            "CompassD7": "Boussole de Turtle Rock",
            "CompassD4": "Boussole de Thieves Town",
            "CompassP3": "Boussole de Hera Tower",
            "CompassD5": "Boussole de Ice Palace",
            "CompassD3": "Boussole de Skulls Woods",
            "CompassD6": "Boussole de Misery Mire",
            "CompassD1": "Boussole de Palace of Darkness",
            "CompassD2": "Boussole de Swamp Palace",
            "CompassA1": "Boussole de Agahnim Tower",
            "CompassP2": "Boussole de Desert Palace",
            "CompassP1": "Boussole de Eastern Palace",
            "CompassH1": "Boussole de Hyrule Castle",
            "CompassH2": "Boussole de Sewers",
            "BigKeyA2": "Grande Clé de Ganons Tower",
            "BigKeyD7": "Grande Clé de Turtle Rock",
            "BigKeyD4": "Grande Clé de Thieves Town",
            "BigKeyP3": "Grande Clé de Hera Tower",
            "BigKeyD5": "Grande Clé de Ice Palace",
            "BigKeyD3": "Grande Clé de Skulls Woods",
            "BigKeyD6": "Grande Clé de Misery Mire",
            "BigKeyD1": "Grande Clé de Palace of Darkness",
            "BigKeyD2": "Grande Clé de Swamp Palace",
            "BigKeyA1": "Grande Clé de Agahnims Tower",
            "BigKeyP2": "Grande Clé de Desert Palace",
            "BigKeyP1": "Grande Clé de Eastern Palace",
            "BigKeyH1": "Grande Clé de Hyrule Castle",
            "BigKeyH2": "Grande Clé de Sewers",
            "KeyH2": "Clé de Sewers",
            "KeyH1": "Clé de Hyrule Castle",
            "KeyP1": "Clé de Eastern Palace",
            "KeyP2": "Clé de Desert Palace",
            "KeyA1": "Clé de Agahnims Tower",
            "KeyD2": "Clé de Swamp Palace",
            "KeyD1": "Clé de Palace of Darkness",
            "KeyD6": "Clé de Misery Mire",
            "KeyD3": "Clé de Skulls Woods",
            "KeyD5": "Clé de Ice Palace",
            "KeyP3": "Clé de Hera Tower",
            "KeyD4": "Clé de Thieves Town",
            "KeyD7": "Clé de Turtle Rock",
            "KeyA2": "Clé de Ganon Tower",
            "KeyGK": "Clé générique",
            "ShopKey": "Key",
            "Crystal1": "Cristal 1",
            "Crystal2": "Cristal 2",
            "Crystal3": "Cristal 3",
            "Crystal4": "Cristal 4",
            "Crystal5": "Cristal 5",
            "Crystal6": "Cristal 6",
            "Crystal7": "Cristal 7",
            "RescueZelda": "Sauver Zelda",
            "DefeatAgahnim": "Vaincre Agahnim",
            "BigRedBomb": "Grosse bombe rouge",
            "DefeatAgahnim2": "Vaincre Agahnim 2",
            "DefeatGanon": "Vaincre Ganon",
            "ChocoboEgg": "Chocobo Egg",
            "NoSlipBoots": "Crampons de Glace",
            "WinterCoat": "Manteau d’hiver",
            "Duck": "Canard",
            "Reindeer1": "Fonceur",
            "Reindeer2": "Danseur",
            "Reindeer3": "Sauteur",
            "Reindeer4": "Fripponne",
            "Reindeer5": "Comète",
            "Reindeer6": "Cupidonne",
            "Reindeer7": "Tonnerre",
            "Reindeer8": "Éclair",
            "Gift1": "Cadeau 1",
            "Gift2": "Cadeau 2",
            "Gift3": "Cadeau 3",
            "Gift4": "Cadeau 4",
            "Gift5": "Cadeau 5",
            "Gift6": "Cadeau 6",
            "Gift7": "Cadeau 7",
            "Coal1": "Charbon",
            "Coal2": "Charbon",
            "GoldenTicket": "Golden Ticket",
            "Armos Knights": "Armos Knights",
            "Lanmolas": "Lanmolas",
            "Moldorm": "Moldorm",
            "Helmasaur King": "Helmasaur King",
            "Arrghus": "Arrghus",
            "Mothula": "Mothula",
            "Blind": "Blind",
            "Kholdstare": "Kholdstare",
            "Vitreous": "Vitreous",
            "Trinexx": "Trinexx",
            "Agahnim": "Agahnim",
            "Agahnim 2": "Agahnim 2",
            "Ganon": "Ganon",
            "Test": "Testing Item"
        },
        "entrance": {
            "title": "Randomizer de portes",
            "switch": {
                "item": "Passer au Randomizer d’objets"
            },
            "rom": {
                "options": "Options de ROM"
            },
            "difficulty": {
                "title": "Difficulté",
                "options": {
                    "easy": "Facile",
                    "normal": "Normal",
                    "hard": "Difficile",
                    "expert": "Expert",
                    "insane": "Insensé"
                }
            },
            "goal": {
                "title": "Objectif",
                "options": {
                    "ganon": "Vaincre Ganon",
                    "crystals": "Cristaux",
                    "dungeons": "Tous les Donjons",
                    "pedestal": "Piédestal de la Master Sword",
                    "triforcehunt": "Pièces de Triforce"
                }
            },
            "logic": {
                "title": "Logique",
                "options": {
                    "NoGlitches": "Sans Glitches"
                }
            },
            "mode": {
                "title": "Réglage",
                "options": {
                    "swordless": "Sans Épée",
                    "open": "Ouvert"
                }
            },
            "shuffle": {
                "title": "Mélanger",
                "options": {
                    "simple": "Simple",
                    "restricted": "Restreint",
                    "full": "Complet",
                    "crossed": "Croisé",
                    "insanity": "Insensé"
                }
            },
            "variation": {
                "title": "Variation",
                "options": {
                    "none": "Aucun",
                    "timed-race": "Chronométrée",
                    "timed-ohko": "Décompte Final",
                    "ohko": "Zéro Coeurs",
                    "triforce-hunt": "Chasse aux morceaux de Triforce",
                    "key-sanity": "Clé-sordre",
                    "retro": "Rétro"
                }
            },
            "generate": {
                "race": "Générer une ROM de course",
                "spoiler_race": "Spoiler de la ROM de Course",
                "casual": "Générer une ROM"
            },
            "details": {
                "title": "Détails du jeu",
                "save_spoiler": "Enregistrer le spoiler",
                "save_rom": "Sauvegarder la ROM"
            }
        }
    }
}
